/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.0.6.0 (NJsonSchema v10.0.23.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { catchError as _observableCatch, mergeMap as _observableMergeMap } from 'rxjs/operators';
import { Observable, of as _observableOf, throwError as _observableThrow } from 'rxjs';
import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';
import { ProblemDetails } from "../../home-page/components/SocialNetworkClient";
import {environment} from "../../../environments/environment";


@Injectable()
export class IdentityClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient) {
        this.http = http;
        this.baseUrl = environment.identityApi;
    }

    /**
     * Authenticates the user.
     * @param body (optional) Query model 'Sign In'.
     * @return Success
     */
    createJwt(body: SignInRequest | undefined): Observable<JwtTokenResponse> {
        let url_ = this.baseUrl + "/_4Tokens/chat-authorization";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateJwt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateJwt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JwtTokenResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JwtTokenResponse>;
        }));
    }

    protected processCreateJwt(response: HttpResponseBase): Observable<JwtTokenResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if(status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = JwtTokenResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if(status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if(status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result401: any = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = ProblemDetails.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if(status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ErrorResponse.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<JwtTokenResponse>(null as any);
    }

    /**
     * Renew Jwt Token the user.
     * @param body (optional) Query model 'Renew token'.
     * @return Success
     */
    renewJwt(body: RenewJwtTokenRequest | undefined): Observable<JwtTokenResponse> {
        let url_ = this.baseUrl + "/api/Authorization/renew";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processRenewJwt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processRenewJwt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JwtTokenResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JwtTokenResponse>;
        }));
    }

    protected processRenewJwt(response: HttpResponseBase): Observable<JwtTokenResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if(status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = JwtTokenResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if(status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if(status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result401: any = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = ProblemDetails.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if(status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ErrorResponse.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<JwtTokenResponse>(null as any);
    }

    /**
     * Authenticates the user.
     * @param signInRequest (optional) Query model 'Sign in'.
     * @return Success
     */
    authorization(signInRequest: SignInRequest | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Authorization";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(signInRequest);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_)
            .pipe(_observableMergeMap(
                (response_: any) => {
                    return this.processAuthorization(response_);
                })).pipe(_observableCatch((response_: any) => {
                if(response_ instanceof HttpResponseBase) {
                    try {
                        return this.processAuthorization(<any>response_);
                    } catch (e) {
                        return <Observable<string>><any>_observableThrow(e);
                    }
                } else
                    return <Observable<string>><any>_observableThrow(response_);
            }));
    }

    protected processAuthorization(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if(status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if(status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if(status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ErrorResponse.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * OAuth authenticates the user.
     * @param model (optional) Query model 'Oauth'.
     * @return Success
     */
    socialAuthorization(model: OAuthRequest | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Authorization/social";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSocialAuthorization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processSocialAuthorization(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processSocialAuthorization(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if(status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if(status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result500: any = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorResponse.fromJS(resultData500);
                return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * Checking user registration via telegram
     * @param id (optional)
     * @return Success
     */
    checkTelegram(id: number | null | undefined): Observable<OAuthTelegramResult> {
        let url_ = this.baseUrl + "/api/Authorization/check-telegram?";
        if(id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckTelegram(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckTelegram(<any>response_);
                } catch (e) {
                    return <Observable<OAuthTelegramResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<OAuthTelegramResult>><any>_observableThrow(response_);
        }));
    }

    protected processCheckTelegram(response: HttpResponseBase): Observable<OAuthTelegramResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = OAuthTelegramResult.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if(status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if(status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result500: any = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorResponse.fromJS(resultData500);
                return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OAuthTelegramResult>(<any>null);
    }

    /**
     * @return Success
     */
    linkedin(): Observable<void> {
        let url_ = this.baseUrl + "/api/Authorization/linkedin";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processLinkedin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processLinkedin(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processLinkedin(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    telegram(): Observable<void> {
        let url_ = this.baseUrl + "/api/Authorization/telegram";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processTelegram(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processTelegram(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processTelegram(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param code (optional)
     * @param state (optional)
     * @return Success
     */
    linkedinCallback(code: string | null | undefined, state: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Authorization/linkedin/callback?";
        if(code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if(state !== undefined)
            url_ += "state=" + encodeURIComponent("" + state) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processLinkedinCallback(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processLinkedinCallback(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processLinkedinCallback(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param token (optional)
     * @return Success
     */
    apple(token: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Authorization/apple?";
        if(token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processApple(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processApple(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processApple(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Callback for Apple sign-in
     * @param code (optional)
     * @param id_token (optional)
     * @param state (optional)
     * @param error (optional)
     * @param user (optional)
     * @return Success
     */
    appleSigninCallback(code: string | null | undefined, id_token: string | null | undefined, state: string | null | undefined, error: string | null | undefined, user: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Authorization/apple-signin";
        url_ = url_.replace(/[?&]$/, "");

        let content_ = "";
        if(code !== undefined)
            content_ += encodeURIComponent("code") + "=" + encodeURIComponent("" + code) + "&";
        if(id_token !== undefined)
            content_ += encodeURIComponent("id_token") + "=" + encodeURIComponent("" + id_token) + "&";
        if(state !== undefined)
            content_ += encodeURIComponent("state") + "=" + encodeURIComponent("" + state) + "&";
        if(error !== undefined)
            content_ += encodeURIComponent("error") + "=" + encodeURIComponent("" + error) + "&";
        if(user !== undefined)
            content_ += encodeURIComponent("user") + "=" + encodeURIComponent("" + user) + "&";
        content_ = content_.replace(/&$/, "");

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/x-www-form-urlencoded",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processAppleSigninCallback(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppleSigninCallback(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processAppleSigninCallback(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Get Contractors
     * @param profileId (optional)
     * @param search (optional)
     * @param contractorSearchType (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     * @return Success
     */
    getContractors(profileId: number | null | undefined, search: string | null | undefined, contractorSearchType: ContractorSearchType | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined): Observable<ContractorsResult> {
        let url_ = this.baseUrl + "/api/Contractors?";
        if(profileId !== undefined)
            url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
        if(search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if(contractorSearchType !== undefined)
            url_ += "contractorSearchType=" + encodeURIComponent("" + contractorSearchType) + "&";
        if(pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if(pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetContractors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContractors(<any>response_);
                } catch (e) {
                    return <Observable<ContractorsResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<ContractorsResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetContractors(response: HttpResponseBase): Observable<ContractorsResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ContractorsResult.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if(status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if(status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContractorsResult>(<any>null);
    }

    /**
     * Add contractors
     * @param request (optional)
     * @return Success
     */
    addContractor(request: AddContractorRequest | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Contractors";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processAddContractor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddContractor(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processAddContractor(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if(status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if(status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Exclude contractor
     * @param profileId (optional)
     * @param contractorProfileId (optional)
     * @return Success
     */
    excludeContractor(profileId: number | null | undefined, contractorProfileId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Contractors?";
        if(profileId !== undefined)
            url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
        if(contractorProfileId !== undefined)
            url_ += "contractorProfileId=" + encodeURIComponent("" + contractorProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExcludeContractor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processExcludeContractor(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processExcludeContractor(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if(status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if(status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Get participants
     * @param currentProfileId (optional)
     * @param profileIds (optional)
     * @param pageSize (optional)
     * @return Success
     */
    getParticipants(currentProfileId: number | null | undefined, profileIds: number[] | null | undefined, pageSize: number | null | undefined): Observable<ParticipantsResult> {
        let url_ = this.baseUrl + "/api/Contractors/participants?";
        if(currentProfileId !== undefined)
            url_ += "currentProfileId=" + encodeURIComponent("" + currentProfileId) + "&";
        if(profileIds !== undefined)
            profileIds && profileIds.forEach(item => {
                url_ += "profileIds=" + encodeURIComponent("" + item) + "&";
            });
        if(pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetParticipants(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParticipants(<any>response_);
                } catch (e) {
                    return <Observable<ParticipantsResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<ParticipantsResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetParticipants(response: HttpResponseBase): Observable<ParticipantsResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ParticipantsResult.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if(status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if(status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ParticipantsResult>(<any>null);
    }

    /**
     * Get Contractor
     * @param profileId (optional)
     * @param contractorProfileId (optional)
     * @return Success
     */
    getContractor(profileId: number | null | undefined, contractorProfileId: number | null | undefined): Observable<ContractorModel> {
        let url_ = this.baseUrl + "/api/Contractors/contractor?";
        if(profileId !== undefined)
            url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
        if(contractorProfileId !== undefined)
            url_ += "contractorProfileId=" + encodeURIComponent("" + contractorProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetContractor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContractor(<any>response_);
                } catch (e) {
                    return <Observable<ContractorModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ContractorModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetContractor(response: HttpResponseBase): Observable<ContractorModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ContractorModel.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if(status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if(status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContractorModel>(<any>null);
    }

    /**
     * Get Contractor by Id
     * @return Success
     */
    getContractorById(profileId: number): Observable<ContractorModel> {
        let url_ = this.baseUrl + "/api/Contractors/contractor/{profileId}";
        if(profileId === undefined || profileId === null)
            throw new Error("The parameter 'profileId' must be defined.");
        url_ = url_.replace("{profileId}", encodeURIComponent("" + profileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetContractorById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContractorById(<any>response_);
                } catch (e) {
                    return <Observable<ContractorModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ContractorModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetContractorById(response: HttpResponseBase): Observable<ContractorModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ContractorModel.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if(status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if(status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContractorModel>(<any>null);
    }

    /**
     * Get Contractor count
     * @param profileId (optional)
     * @param contractorSearchType (optional)
     * @return Success
     */
    getContractorCount(profileId: number | null | undefined, contractorSearchType: ContractorSearchType2 | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/Contractors/contractor-count?";
        if(profileId !== undefined)
            url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
        if(contractorSearchType !== undefined)
            url_ += "contractorSearchType=" + encodeURIComponent("" + contractorSearchType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetContractorCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContractorCount(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetContractorCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if(status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if(status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * Get countries dictionary
     * @return Success
     */
    getCountries(): Observable<MultipleQueryResultOfCountry> {
        let url_ = this.baseUrl + "/api/Dictionaries/countries";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCountries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountries(<any>response_);
                } catch (e) {
                    return <Observable<MultipleQueryResultOfCountry>><any>_observableThrow(e);
                }
            } else
                return <Observable<MultipleQueryResultOfCountry>><any>_observableThrow(response_);
        }));
    }

    protected processGetCountries(response: HttpResponseBase): Observable<MultipleQueryResultOfCountry> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = MultipleQueryResultOfCountry.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if(status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if(status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MultipleQueryResultOfCountry>(<any>null);
    }

    /**
     * Get CountryDocumentFields dictionary
     * @return Success
     */
    getCountryDocumentFields(): Observable<MultipleQueryResultOfCountryDocumentField> {
        let url_ = this.baseUrl + "/api/Dictionaries/docfields";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCountryDocumentFields(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountryDocumentFields(<any>response_);
                } catch (e) {
                    return <Observable<MultipleQueryResultOfCountryDocumentField>><any>_observableThrow(e);
                }
            } else
                return <Observable<MultipleQueryResultOfCountryDocumentField>><any>_observableThrow(response_);
        }));
    }

    protected processGetCountryDocumentFields(response: HttpResponseBase): Observable<MultipleQueryResultOfCountryDocumentField> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = MultipleQueryResultOfCountryDocumentField.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if(status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if(status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MultipleQueryResultOfCountryDocumentField>(<any>null);
    }

    /**
     * Change email
     * @param request (optional)
     * @return Success
     */
    changeEmail(request: ChangeEmailViewModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Emails/change";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processChangeEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeEmail(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processChangeEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if(status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if(status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Confirm change email
     * @param request (optional)
     * @return Success
     */
    confirmChangeEmail(request: ConfirmChangeEmailViewModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Emails/confirm-change";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processConfirmChangeEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmChangeEmail(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processConfirmChangeEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if(status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if(status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Send confirmation code
     * @param request (optional)
     * @return Success
     */
    sendConfirmationCode(request: SendConfirmationCodeViewModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Emails/send-code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSendConfirmationCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendConfirmationCode(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendConfirmationCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if(status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if(status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Confirm email
     * @param request (optional)
     * @return Success
     */
    confirmEmailWithCode(request: ConfirmEmailViewModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Emails/confirm-code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processConfirmEmailWithCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmEmailWithCode(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processConfirmEmailWithCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if(status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if(status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Resend confirmation code
     * @return Success
     */
    resendConfirmationCode(): Observable<void> {
        let url_ = this.baseUrl + "/api/Emails/resend-code";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processResendConfirmationCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processResendConfirmationCode(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processResendConfirmationCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if(status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if(status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Resend confirmation code
     * @return Success
     */
    resendConfirmationCode2(email: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Emails/resend-code/{email}";
        if(email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processResendConfirmationCode2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processResendConfirmationCode2(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processResendConfirmationCode2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if(status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if(status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Get oracles
     * @param profileId (optional)
     * @param search (optional)
     * @param oracleTabType (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     * @return Success
     */
    getOracles(profileId: number | null | undefined, search: string | null | undefined, oracleTabType: OracleTabType | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined): Observable<OraclesResult> {
        let url_ = this.baseUrl + "/api/Oracles?";
        if(profileId !== undefined)
            url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
        if(search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if(oracleTabType !== undefined)
            url_ += "oracleTabType=" + encodeURIComponent("" + oracleTabType) + "&";
        if(pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if(pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetOracles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOracles(<any>response_);
                } catch (e) {
                    return <Observable<OraclesResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<OraclesResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetOracles(response: HttpResponseBase): Observable<OraclesResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = OraclesResult.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if(status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if(status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OraclesResult>(<any>null);
    }

    /**
     * Add oracle
     * @param request (optional)
     * @return Success
     */
    addOracle(request: OracleRequest | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Oracles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processAddOracle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOracle(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processAddOracle(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if(status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if(status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Exclude oracle
     * @param profileId (optional)
     * @param oracleProfileId (optional)
     * @return Success
     */
    excludeOracle(profileId: number | null | undefined, oracleProfileId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Oracles?";
        if(profileId !== undefined)
            url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
        if(oracleProfileId !== undefined)
            url_ += "oracleProfileId=" + encodeURIComponent("" + oracleProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExcludeOracle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processExcludeOracle(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processExcludeOracle(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if(status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if(status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Get all oracles
     * @param profileId (optional)
     * @return Success
     */
    getAllCurrentOracles(profileId: number | null | undefined): Observable<OraclesResult> {
        let url_ = this.baseUrl + "/api/Oracles/all-current?";
        if(profileId !== undefined)
            url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllCurrentOracles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCurrentOracles(<any>response_);
                } catch (e) {
                    return <Observable<OraclesResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<OraclesResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCurrentOracles(response: HttpResponseBase): Observable<OraclesResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = OraclesResult.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if(status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if(status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OraclesResult>(<any>null);
    }

    /**
     * Get oracle
     * @param profileId (optional)
     * @param oracleProfileId (optional)
     * @return Success
     */
    getOracle(profileId: number | null | undefined, oracleProfileId: number | null | undefined): Observable<OracleModel> {
        let url_ = this.baseUrl + "/api/Oracles/oracle?";
        if(profileId !== undefined)
            url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
        if(oracleProfileId !== undefined)
            url_ += "oracleProfileId=" + encodeURIComponent("" + oracleProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetOracle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOracle(<any>response_);
                } catch (e) {
                    return <Observable<OracleModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<OracleModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetOracle(response: HttpResponseBase): Observable<OracleModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = OracleModel.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if(status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if(status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OracleModel>(<any>null);
    }

    /**
     * Toggle oracle
     * @param request (optional)
     * @return Success
     */
    toggleOracle(request: ToggleOracleRequest | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Oracles/toggle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processToggleOracle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processToggleOracle(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processToggleOracle(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if(status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if(status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Get oracle count
     * @param profileId (optional)
     * @param oracleTabType (optional)
     * @return Success
     */
    getOracleCount(profileId: number | null | undefined, oracleTabType: OracleTabType2 | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/Oracles/oracle-count?";
        if(profileId !== undefined)
            url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
        if(oracleTabType !== undefined)
            url_ += "oracleTabType=" + encodeURIComponent("" + oracleTabType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetOracleCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOracleCount(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetOracleCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if(status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if(status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * Get organization agent
     * @param organizationProfileId (optional)
     * @return Success
     */
    getOrganizationAgent(organizationProfileId: number | null | undefined): Observable<AgentResult> {
        let url_ = this.baseUrl + "/api/OrganizationAgents/organization-agent?";
        if(organizationProfileId !== undefined)
            url_ += "organizationProfileId=" + encodeURIComponent("" + organizationProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetOrganizationAgent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationAgent(<any>response_);
                } catch (e) {
                    return <Observable<AgentResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<AgentResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrganizationAgent(response: HttpResponseBase): Observable<AgentResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AgentResult.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if(status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if(status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AgentResult>(<any>null);
    }

    /**
     * Get organization for agent
     * @param agentProfileId (optional)
     * @return Success
     */
    getOrganizationForAgent(agentProfileId: number | null | undefined): Observable<OrganizationResult[]> {
        let url_ = this.baseUrl + "/api/OrganizationAgents/organization-for-agent?";
        if(agentProfileId !== undefined)
            url_ += "agentProfileId=" + encodeURIComponent("" + agentProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetOrganizationForAgent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationForAgent(<any>response_);
                } catch (e) {
                    return <Observable<OrganizationResult[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrganizationResult[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrganizationForAgent(response: HttpResponseBase): Observable<OrganizationResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if(Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(OrganizationResult.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if(status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if(status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrganizationResult[]>();
    }

    /**
     * Get organization requests
     * @param profileId (optional)
     * @return Success
     */
    getOrganizationRequests(profileId: number | null | undefined): Observable<OrganizationResult[]> {
        let url_ = this.baseUrl + "/api/OrganizationAgents/organization-requests?";
        if(profileId !== undefined)
            url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetOrganizationRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationRequests(<any>response_);
                } catch (e) {
                    return <Observable<OrganizationResult[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrganizationResult[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrganizationRequests(response: HttpResponseBase): Observable<OrganizationResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if(Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(OrganizationResult.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if(status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if(status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrganizationResult[]>();
    }

    /**
     * Add organization agent
     * @param model (optional)
     * @return Success
     */
    addOrganizationAgent(model: OrganizationAgentViewModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/OrganizationAgents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processAddOrganizationAgent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrganizationAgent(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processAddOrganizationAgent(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if(status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if(status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Set organization agent request type
     * @param model (optional)
     * @return Success
     */
    setOrganizationAgentRequestType(model: SetOrganizationAgentRequestTypeViewModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/OrganizationAgents/request-type";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSetOrganizationAgentRequestType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetOrganizationAgentRequestType(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetOrganizationAgentRequestType(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if(status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if(status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Change user password.
     * @param changePasswordRequest (optional) Query model 'Change password'.
     * @return Success
     */
    changePassword(changePasswordRequest: ChangePasswordRequest | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/users/password/current";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(changePasswordRequest);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if(status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if(status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if(status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ErrorResponse.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Set user password.
     * @param setPasswordRequest (optional) Query model 'Set password'.
     * @return Success
     */
    setPassword(setPasswordRequest: SetPasswordRequest | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/users/password/set";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(setPasswordRequest);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetPassword(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetPassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if(status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if(status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if(status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ErrorResponse.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Check user password.
     * @return Success
     */
    checkPassword(): Observable<CheckPasswordResult> {
        let url_ = this.baseUrl + "/api/users/check-password";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckPassword(<any>response_);
                } catch (e) {
                    return <Observable<CheckPasswordResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<CheckPasswordResult>><any>_observableThrow(response_);
        }));
    }

    protected processCheckPassword(response: HttpResponseBase): Observable<CheckPasswordResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CheckPasswordResult.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if(status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if(status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result500: any = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorResponse.fromJS(resultData500);
                return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CheckPasswordResult>(<any>null);
    }

    /**
     * Recovery user password.
     * @param request (optional) Model for confirmation.
     * @return Success
     */
    recoverPassword(request: EmailWithConfirmationActionRequest | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/users/password/recovery";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processRecoverPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processRecoverPassword(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRecoverPassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if(status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if(status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ErrorResponse.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Confirm recovery user password.
     * @param confirmPasswordRecoveryRequest (optional) Query model 'Confirm password recovery'.
     * @return Success
     */
    recoverConfirm(confirmPasswordRecoveryRequest: ConfirmPasswordRecoveryRequest | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/users/password/recovery/confirm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(confirmPasswordRecoveryRequest);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processRecoverConfirm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processRecoverConfirm(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRecoverConfirm(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if(status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if(status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ErrorResponse.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Get the list of user's profiles.
     * @return Success
     */
    getUserProfiles(): Observable<MultipleQueryResultOfProfile> {
        let url_ = this.baseUrl + "/api/Profiles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUserProfiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserProfiles(<any>response_);
                } catch (e) {
                    return <Observable<MultipleQueryResultOfProfile>><any>_observableThrow(e);
                }
            } else
                return <Observable<MultipleQueryResultOfProfile>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserProfiles(response: HttpResponseBase): Observable<MultipleQueryResultOfProfile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = MultipleQueryResultOfProfile.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if(status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if(status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MultipleQueryResultOfProfile>(<any>null);
    }

    /**
     * Delete profile
     * @param id (optional)
     * @return Success
     */
    deleteProfile(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Profiles?";
        if(id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProfile(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteProfile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if(status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if(status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Get personal profile by id.
     * @return Success
     */
    getPersonalProfile(profileId: number, isCheckAccessField: boolean): Observable<PersonalProfileResult> {
        let url_ = this.baseUrl + "/api/Profiles/personal/{profileId}/{isCheckAccessField}";
        if(profileId === undefined || profileId === null)
            throw new Error("The parameter 'profileId' must be defined.");
        url_ = url_.replace("{profileId}", encodeURIComponent("" + profileId));
        if(isCheckAccessField === undefined || isCheckAccessField === null)
            throw new Error("The parameter 'isCheckAccessField' must be defined.");
        url_ = url_.replace("{isCheckAccessField}", encodeURIComponent("" + isCheckAccessField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPersonalProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonalProfile(<any>response_);
                } catch (e) {
                    return <Observable<PersonalProfileResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<PersonalProfileResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetPersonalProfile(response: HttpResponseBase): Observable<PersonalProfileResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PersonalProfileResult.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if(status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if(status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PersonalProfileResult>(<any>null);
    }

    /**
     * Get organization profile by id.
     * @return Success
     */
    getOrganizationProfile(profileId: number, isCheckAccessField: boolean): Observable<OrganizationProfileResult> {
        let url_ = this.baseUrl + "/api/Profiles/organization/{profileId}/{isCheckAccessField}";
        if(profileId === undefined || profileId === null)
            throw new Error("The parameter 'profileId' must be defined.");
        url_ = url_.replace("{profileId}", encodeURIComponent("" + profileId));
        if(isCheckAccessField === undefined || isCheckAccessField === null)
            throw new Error("The parameter 'isCheckAccessField' must be defined.");
        url_ = url_.replace("{isCheckAccessField}", encodeURIComponent("" + isCheckAccessField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetOrganizationProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationProfile(<any>response_);
                } catch (e) {
                    return <Observable<OrganizationProfileResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrganizationProfileResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrganizationProfile(response: HttpResponseBase): Observable<OrganizationProfileResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = OrganizationProfileResult.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if(status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if(status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrganizationProfileResult>(<any>null);
    }

    /**
     * Edit personal profile data
     * @param request (optional) Query model 'Edit personal profile'.
     * @return Success
     */
    editPersonalProfile(request: EditPersonalProfileViewModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Profiles/personal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processEditPersonalProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditPersonalProfile(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processEditPersonalProfile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if(status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if(status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Create personal profile
     * @param request (optional) Query model 'Personal profile'.
     * @return Success
     */
    createPersonalProfile(request: PersonalProfileViewModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Profiles/personal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreatePersonalProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePersonalProfile(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreatePersonalProfile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if(status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if(status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Edit organization profile data
     * @param request (optional) Query model 'Edit organization profile'.
     * @return Success
     */
    editOrganizationProfile(request: EditOrganizationProfileViewModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Profiles/organization";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processEditOrganizationProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditOrganizationProfile(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processEditOrganizationProfile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if(status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if(status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Create organization profile
     * @param request (optional) Query model 'Organization profile'.
     * @return Success
     */
    createOrganizationProfile(request: OrganizationProfileViewModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Profiles/organization";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrganizationProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrganizationProfile(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrganizationProfile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if(status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if(status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Create new document pattern
     * @param request (optional) Query model 'Profile document pattern'.
     * @return Success
     */
    createProfileDocumentPattern(request: ProfileDocumentPatternViewModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Profiles/document-pattern";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateProfileDocumentPattern(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProfileDocumentPattern(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateProfileDocumentPattern(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if(status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if(status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Change profile avatar
     * @param request (optional) Query model 'Change profile avatar'.
     * @return Success
     */
    changeAvatar(request: ChangeProfileAvatarViewModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Profiles/change-avatar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processChangeAvatar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeAvatar(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processChangeAvatar(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if(status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if(status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Get profile by id.
     * @return Success
     */
    getProfileById(profileId: number): Observable<Profile> {
        let url_ = this.baseUrl + "/api/Profiles/profile/{profileId}";
        if(profileId === undefined || profileId === null)
            throw new Error("The parameter 'profileId' must be defined.");
        url_ = url_.replace("{profileId}", encodeURIComponent("" + profileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProfileById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfileById(<any>response_);
                } catch (e) {
                    return <Observable<Profile>><any>_observableThrow(e);
                }
            } else
                return <Observable<Profile>><any>_observableThrow(response_);
        }));
    }

    protected processGetProfileById(response: HttpResponseBase): Observable<Profile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Profile.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if(status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if(status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Profile>(<any>null);
    }

    /**
     * Get profiles by telegramId
     * @param telegramIds (optional)
     * @return Success
     */
    getProfilesByTelegramId(telegramIds: string | null | undefined): Observable<ProfilesByTelegramResult> {
        let url_ = this.baseUrl + "/api/Profiles/profiles-by-telegram?";
        if(telegramIds !== undefined)
            url_ += "telegramIds=" + encodeURIComponent("" + telegramIds) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProfilesByTelegramId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfilesByTelegramId(<any>response_);
                } catch (e) {
                    return <Observable<ProfilesByTelegramResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProfilesByTelegramResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetProfilesByTelegramId(response: HttpResponseBase): Observable<ProfilesByTelegramResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProfilesByTelegramResult.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if(status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if(status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProfilesByTelegramResult>(<any>null);
    }

    /**
     * Change profile email
     * @param request (optional)
     * @return Success
     */
    changeProfileEmail(request: ChangeProfileEmailViewModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Profiles/change-email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processChangeProfileEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeProfileEmail(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processChangeProfileEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if(status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if(status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Confirm change profile email
     * @param request (optional)
     * @return Success
     */
    confirmChangeProfileEmail(request: ConfirmChangeProfileEmailViewModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Profiles/confirm-change-email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processConfirmChangeProfileEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmChangeProfileEmail(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processConfirmChangeProfileEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if(status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if(status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Resend confirmation code
     * @return Success
     */
    resendConfirmationCodeForChangeProfileEmail(profileId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Profiles/resend-code/{profileId}";
        if(profileId === undefined || profileId === null)
            throw new Error("The parameter 'profileId' must be defined.");
        url_ = url_.replace("{profileId}", encodeURIComponent("" + profileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processResendConfirmationCodeForChangeProfileEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processResendConfirmationCodeForChangeProfileEmail(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processResendConfirmationCodeForChangeProfileEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if(status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if(status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Delete profile KYC field
     * @param model (optional)
     * @return Success
     */
    deleteProfileKycField(model: DeleteProfileKycFieldViewModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Profiles/delete-kyc-field";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteProfileKycField(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProfileKycField(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteProfileKycField(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if(status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if(status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Subscribe to profile
     * @param model (optional) Query model 'Subscribe to profile'.
     * @return Success
     */
    subscribeToProfile(model: SubscribeViewModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Profiles/subscribe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSubscribeToProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubscribeToProfile(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSubscribeToProfile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if(status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if(status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Unsubscribe from profile
     * @param model (optional) Query model 'Subscribe to profile'.
     * @return Success
     */
    unsubscribeFromProfile(model: SubscribeViewModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Profiles/unsubscribe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUnsubscribeFromProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnsubscribeFromProfile(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUnsubscribeFromProfile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if(status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if(status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Get cryptonomica promocode
     * @return Success
     */
    getCryptonomicaPromoCode(): Observable<CryptonomicaPromoCodeResult> {
        let url_ = this.baseUrl + "/api/ProfileVerification/cryptonomica-promocode";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCryptonomicaPromoCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCryptonomicaPromoCode(<any>response_);
                } catch (e) {
                    return <Observable<CryptonomicaPromoCodeResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<CryptonomicaPromoCodeResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetCryptonomicaPromoCode(response: HttpResponseBase): Observable<CryptonomicaPromoCodeResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CryptonomicaPromoCodeResult.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if(status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if(status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CryptonomicaPromoCodeResult>(<any>null);
    }

    /**
     * Get cryptonomica verify profile
     * @param profileId (optional)
     * @param fingerprint (optional)
     * @return Success
     */
    cryptonomicaVerifyProfile(profileId: number | null | undefined, fingerprint: string | null | undefined): Observable<CryptonomicaVerificationResult> {
        let url_ = this.baseUrl + "/api/ProfileVerification/cryptonomica-verify?";
        if(profileId !== undefined)
            url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
        if(fingerprint !== undefined)
            url_ += "fingerprint=" + encodeURIComponent("" + fingerprint) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCryptonomicaVerifyProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processCryptonomicaVerifyProfile(<any>response_);
                } catch (e) {
                    return <Observable<CryptonomicaVerificationResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<CryptonomicaVerificationResult>><any>_observableThrow(response_);
        }));
    }

    protected processCryptonomicaVerifyProfile(response: HttpResponseBase): Observable<CryptonomicaVerificationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CryptonomicaVerificationResult.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if(status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if(status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CryptonomicaVerificationResult>(<any>null);
    }

    /**
     * Save fingerprint
     * @param model (optional)
     * @return Success
     */
    saveCryptonomicaFingerprint(model: VerifyProfileRequest | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ProfileVerification/cryptonomica-fingerprint";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSaveCryptonomicaFingerprint(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveCryptonomicaFingerprint(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSaveCryptonomicaFingerprint(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if(status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if(status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Sends new confirmation token
     * @param request (optional) Model for confirmation.
     * @return Success
     */
    resendVerification(request: EmailWithConfirmationActionRequest | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Registration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processResendVerification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processResendVerification(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processResendVerification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if(status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if(status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if(status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ErrorResponse.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Creates a new user.
     * @param createAccountRequest (optional) Query model 'Create account'.
     * @return Success
     */
    createUser(createAccountRequest: CreateAccountRequest | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Registration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createAccountRequest);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUser(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if(status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if(status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if(status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ErrorResponse.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Confirm user mail.
     * @param confirmEmailRequest (optional) Query model 'Confirm email'.
     * @return Success
     */
    confirmEmail(confirmEmailRequest: ConfirmEmailRequest | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Registration/email/confirmation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(confirmEmailRequest);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processConfirmEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmEmail(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processConfirmEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if(status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if(status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if(status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ErrorResponse.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Sharing information
     * @return Success
     */
    share(encodedString: string): Observable<void> {
        let url_ = this.baseUrl + "/Share/{encodedString}";
        if(encodedString === undefined || encodedString === null)
            throw new Error("The parameter 'encodedString' must be defined.");
        url_ = url_.replace("{encodedString}", encodeURIComponent("" + encodedString));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processShare(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processShare(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processShare(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Get current user data
     * @return Success
     */
    getCurrentUser(): Observable<UserResponse> {
        let url_ = this.baseUrl + "/api/users/current";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCurrentUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if(response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentUser(<any>response_);
                } catch (e) {
                    return <Observable<UserResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetCurrentUser(response: HttpResponseBase): Observable<UserResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if(response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        ;
        if(status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if(status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if(status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if(status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result404: any = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ErrorResponse.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if(status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserResponse>(<any>null);
    }
}

export class RenewJwtTokenRequest implements IRenewJwtTokenRequest {
    token?: string | undefined;

    constructor(data?: IRenewJwtTokenRequest) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if(_data) {
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): RenewJwtTokenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RenewJwtTokenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        return data;
    }
}

export interface IRenewJwtTokenRequest {
    token?: string | undefined;
}

export class SignInRequest implements ISignInRequest {
    email?: string | undefined;
    password?: string | undefined;

    constructor(data?: ISignInRequest) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if(data) {
            this.email = data["email"];
            this.password = data["password"];
        }
    }

    static fromJS(data: any): SignInRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SignInRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["password"] = this.password;
        return data;
    }
}

export class SignInResponse implements ISignInResponse {
    twoFaRequired?: boolean;
    twoFaToken?: string | undefined;
    latestTwoFaRemindDate?: Date | undefined;
    access_token?: string | undefined;
    issued?: Date | undefined;
    expires_in?: number | undefined;
    refresh_token?: string | undefined;

    constructor(data?: ISignInResponse) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if(_data) {
            this.twoFaRequired = _data["twoFaRequired"];
            this.twoFaToken = _data["twoFaToken"];
            this.latestTwoFaRemindDate = _data["latestTwoFaRemindDate"] ? new Date(_data["latestTwoFaRemindDate"].toString()) : <any>undefined;
            this.access_token = _data["access_token"];
            this.issued = _data["issued"] ? new Date(_data["issued"].toString()) : <any>undefined;
            this.expires_in = _data["expires_in"];
            this.refresh_token = _data["refresh_token"];
        }
    }

    static fromJS(data: any): SignInResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SignInResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["twoFaRequired"] = this.twoFaRequired;
        data["twoFaToken"] = this.twoFaToken;
        data["latestTwoFaRemindDate"] = this.latestTwoFaRemindDate ? this.latestTwoFaRemindDate.toISOString() : <any>undefined;
        data["access_token"] = this.access_token;
        data["issued"] = this.issued ? this.issued.toISOString() : <any>undefined;
        data["expires_in"] = this.expires_in;
        data["refresh_token"] = this.refresh_token;
        return data;
    }
}

export interface ISignInResponse {
    twoFaRequired?: boolean;
    twoFaToken?: string | undefined;
    latestTwoFaRemindDate?: Date | undefined;
    access_token?: string | undefined;
    issued?: Date | undefined;
    expires_in?: number | undefined;
    refresh_token?: string | undefined;
}

export enum OAuthSystem {
    Google = "Google",
    Facebook = "Facebook",
    LinkedIn = "LinkedIn",
    Telegram = "Telegram",
    AppleId = "AppleId",
}

export interface ISignInRequest {
    email?: string | undefined;
    password?: string | undefined;
}

export class ErrorResponse implements IErrorResponse {
    message?: string | undefined;

    constructor(data?: IErrorResponse) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if(data) {
            this.message = data["message"];
        }
    }

    static fromJS(data: any): ErrorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        return data;
    }
}

export interface IErrorResponse {
    message?: string | undefined;
}


export class JwtTokenResponse implements IJwtTokenResponse {
    access_token?: string | undefined;
    issued?: Date | undefined;
    expires_in?: number | undefined;
    refresh_token?: string | undefined;

    constructor(data?: IJwtTokenResponse) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if(_data) {
            this.access_token = _data["access_token"];
            this.issued = _data["issued"] ? new Date(_data["issued"].toString()) : <any>undefined;
            this.expires_in = _data["expires_in"];
            this.refresh_token = _data["refresh_token"];
        }
    }

    static fromJS(data: any): JwtTokenResponse {
        data = typeof data === 'object' ? data : {};
        let result = new JwtTokenResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["access_token"] = this.access_token;
        data["issued"] = this.issued ? this.issued.toISOString() : <any>undefined;
        data["expires_in"] = this.expires_in;
        data["refresh_token"] = this.refresh_token;
        return data;
    }
}

export interface IJwtTokenResponse {
    access_token?: string | undefined;
    issued?: Date | undefined;
    expires_in?: number | undefined;
    refresh_token?: string | undefined;
}

export class OAuthRequest implements IOAuthRequest {
    accessToken?: string | undefined;
    system?: OAuthRequestSystem | undefined;

    constructor(data?: IOAuthRequest) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if(data) {
            this.accessToken = data["accessToken"];
            this.system = data["system"];
        }
    }

    static fromJS(data: any): OAuthRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OAuthRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["system"] = this.system;
        return data;
    }
}

export interface IOAuthRequest {
    accessToken?: string | undefined;
    system?: OAuthRequestSystem | undefined;
}

export class OAuthTelegramResult implements IOAuthTelegramResult {
    isRegistered?: boolean | undefined;

    constructor(data?: IOAuthTelegramResult) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if(data) {
            this.isRegistered = data["isRegistered"];
        }
    }

    static fromJS(data: any): OAuthTelegramResult {
        data = typeof data === 'object' ? data : {};
        let result = new OAuthTelegramResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isRegistered"] = this.isRegistered;
        return data;
    }
}

export interface IOAuthTelegramResult {
    isRegistered?: boolean | undefined;
}

export class ContractorsResult implements IContractorsResult {
    contractors?: ContractorModel[] | undefined;
    totalCount?: number | undefined;

    constructor(data?: IContractorsResult) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if(data) {
            if(Array.isArray(data["contractors"])) {
                this.contractors = [] as any;
                for (let item of data["contractors"])
                    this.contractors!.push(ContractorModel.fromJS(item));
            }
            this.totalCount = data["totalCount"];
        }
    }

    static fromJS(data: any): ContractorsResult {
        data = typeof data === 'object' ? data : {};
        let result = new ContractorsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if(Array.isArray(this.contractors)) {
            data["contractors"] = [];
            for (let item of this.contractors)
                data["contractors"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IContractorsResult {
    contractors?: ContractorModel[] | undefined;
    totalCount?: number | undefined;
}

export class ContractorModel implements IContractorModel {
    fullName?: string | undefined;
    description?: string | undefined;
    contractorProfileId?: number | undefined;
    isAdded?: boolean | undefined;
    isOracle?: boolean | undefined;
    avatarUrl?: string | undefined;
    profileType?: ContractorModelProfileType | undefined;

    constructor(data?: IContractorModel) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if(data) {
            this.fullName = data["fullName"];
            this.description = data["description"];
            this.contractorProfileId = data["contractorProfileId"];
            this.isAdded = data["isAdded"];
            this.isOracle = data["isOracle"];
            this.avatarUrl = data["avatarUrl"];
            this.profileType = data["profileType"];
        }
    }

    static fromJS(data: any): ContractorModel {
        data = typeof data === 'object' ? data : {};
        let result = new ContractorModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["description"] = this.description;
        data["contractorProfileId"] = this.contractorProfileId;
        data["isAdded"] = this.isAdded;
        data["isOracle"] = this.isOracle;
        data["avatarUrl"] = this.avatarUrl;
        data["profileType"] = this.profileType;
        return data;
    }
}

export interface IContractorModel {
    fullName?: string | undefined;
    description?: string | undefined;
    contractorProfileId?: number | undefined;
    isAdded?: boolean | undefined;
    isOracle?: boolean | undefined;
    avatarUrl?: string | undefined;
    profileType?: ContractorModelProfileType | undefined;
}

export class AddContractorRequest implements IAddContractorRequest {
    profileId?: number | undefined;
    contractorProfileId?: number | undefined;

    constructor(data?: IAddContractorRequest) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if(data) {
            this.profileId = data["profileId"];
            this.contractorProfileId = data["contractorProfileId"];
        }
    }

    static fromJS(data: any): AddContractorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddContractorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profileId"] = this.profileId;
        data["contractorProfileId"] = this.contractorProfileId;
        return data;
    }
}

export interface IAddContractorRequest {
    profileId?: number | undefined;
    contractorProfileId?: number | undefined;
}

export class ParticipantsResult implements IParticipantsResult {
    participants?: ContractorModel[] | undefined;
    totalCount?: number | undefined;

    constructor(data?: IParticipantsResult) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if(data) {
            if(Array.isArray(data["participants"])) {
                this.participants = [] as any;
                for (let item of data["participants"])
                    this.participants!.push(ContractorModel.fromJS(item));
            }
            this.totalCount = data["totalCount"];
        }
    }

    static fromJS(data: any): ParticipantsResult {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if(Array.isArray(this.participants)) {
            data["participants"] = [];
            for (let item of this.participants)
                data["participants"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IParticipantsResult {
    participants?: ContractorModel[] | undefined;
    totalCount?: number | undefined;
}

export class MultipleQueryResultOfCountry implements IMultipleQueryResultOfCountry {
    count?: number | undefined;
    data?: Country[] | undefined;

    constructor(data?: IMultipleQueryResultOfCountry) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if(data) {
            this.count = data["count"];
            if(Array.isArray(data["data"])) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(Country.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MultipleQueryResultOfCountry {
        data = typeof data === 'object' ? data : {};
        let result = new MultipleQueryResultOfCountry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if(Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMultipleQueryResultOfCountry {
    count?: number | undefined;
    data?: Country[] | undefined;
}

export class Country implements ICountry {
    name?: string | undefined;
    alpha3Code?: string | undefined;
    alpha2Code?: string | undefined;
    profiles?: PersonalProfile[] | undefined;
    countryDocumentFields?: CountryDocumentField[] | undefined;
    profileDocuments?: ProfileDocument[] | undefined;
    id?: number | undefined;

    constructor(data?: ICountry) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if(data) {
            this.name = data["name"];
            this.alpha3Code = data["alpha3Code"];
            this.alpha2Code = data["alpha2Code"];
            if(Array.isArray(data["profiles"])) {
                this.profiles = [] as any;
                for (let item of data["profiles"])
                    this.profiles!.push(PersonalProfile.fromJS(item));
            }
            if(Array.isArray(data["countryDocumentFields"])) {
                this.countryDocumentFields = [] as any;
                for (let item of data["countryDocumentFields"])
                    this.countryDocumentFields!.push(CountryDocumentField.fromJS(item));
            }
            if(Array.isArray(data["profileDocuments"])) {
                this.profileDocuments = [] as any;
                for (let item of data["profileDocuments"])
                    this.profileDocuments!.push(ProfileDocument.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): Country {
        data = typeof data === 'object' ? data : {};
        let result = new Country();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["alpha3Code"] = this.alpha3Code;
        data["alpha2Code"] = this.alpha2Code;
        if(Array.isArray(this.profiles)) {
            data["profiles"] = [];
            for (let item of this.profiles)
                data["profiles"].push(item.toJSON());
        }
        if(Array.isArray(this.countryDocumentFields)) {
            data["countryDocumentFields"] = [];
            for (let item of this.countryDocumentFields)
                data["countryDocumentFields"].push(item.toJSON());
        }
        if(Array.isArray(this.profileDocuments)) {
            data["profileDocuments"] = [];
            for (let item of this.profileDocuments)
                data["profileDocuments"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface ICountry {
    name?: string | undefined;
    alpha3Code?: string | undefined;
    alpha2Code?: string | undefined;
    profiles?: PersonalProfile[] | undefined;
    countryDocumentFields?: CountryDocumentField[] | undefined;
    profileDocuments?: ProfileDocument[] | undefined;
    id?: number | undefined;
}

export class PersonalProfile implements IPersonalProfile {
    birthDate?: Date | undefined;
    city?: string | undefined;
    address?: string | undefined;
    postalCode?: number | undefined;
    province?: string | undefined;
    telegram?: string | undefined;
    skype?: string | undefined;
    isDisplayCountryId?: boolean | undefined;
    isDisplayBirthDate?: boolean | undefined;
    isDisplayTelegram?: boolean | undefined;
    isDisplaySkype?: boolean | undefined;
    isDisplayCity?: boolean | undefined;
    isDisplayAddress?: boolean | undefined;
    countryId?: number | undefined;
    country?: Country | undefined;
    organizations?: OrganizationAgent[] | undefined;
    profileDocuments?: ProfileDocument[] | undefined;
    profileDocumentPatterns?: ProfileDocumentPattern[] | undefined;
    avatarUrl?: string | undefined;
    name?: string | undefined;
    isDefault?: boolean | undefined;
    isOracle?: boolean | undefined;
    userId?: string | undefined;
    email?: string | undefined;
    isDisplayEmail?: boolean | undefined;
    createDate?: Date | undefined;
    fullName?: string | undefined;
    phoneNumber?: string | undefined;
    isDisplayPhoneNumber?: boolean | undefined;
    description?: string | undefined;
    deletedDate?: Date | undefined;
    fingerprint?: string | undefined;
    user?: User | undefined;
    contractors?: ProfilesContractor[] | undefined;
    oracles?: ProfilesOracle[] | undefined;
    subscribers?: Subscription[] | undefined;
    subscriptions?: Subscription[] | undefined;
    profilesOracles?: ProfilesOracle[] | undefined;
    profilesContractors?: ProfilesContractor[] | undefined;
    profileUnconfirmedEmails?: ProfileUnconfirmedEmail[] | undefined;
    id?: number | undefined;

    constructor(data?: IPersonalProfile) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if(data) {
            this.birthDate = data["birthDate"] ? new Date(data["birthDate"].toString()) : <any>undefined;
            this.city = data["city"];
            this.address = data["address"];
            this.postalCode = data["postalCode"];
            this.province = data["province"];
            this.telegram = data["telegram"];
            this.skype = data["skype"];
            this.isDisplayCountryId = data["isDisplayCountryId"];
            this.isDisplayBirthDate = data["isDisplayBirthDate"];
            this.isDisplayTelegram = data["isDisplayTelegram"];
            this.isDisplaySkype = data["isDisplaySkype"];
            this.isDisplayCity = data["isDisplayCity"];
            this.isDisplayAddress = data["isDisplayAddress"];
            this.countryId = data["countryId"];
            this.country = data["country"] ? Country.fromJS(data["country"]) : <any>undefined;
            if(Array.isArray(data["organizations"])) {
                this.organizations = [] as any;
                for (let item of data["organizations"])
                    this.organizations!.push(OrganizationAgent.fromJS(item));
            }
            if(Array.isArray(data["profileDocuments"])) {
                this.profileDocuments = [] as any;
                for (let item of data["profileDocuments"])
                    this.profileDocuments!.push(ProfileDocument.fromJS(item));
            }
            if(Array.isArray(data["profileDocumentPatterns"])) {
                this.profileDocumentPatterns = [] as any;
                for (let item of data["profileDocumentPatterns"])
                    this.profileDocumentPatterns!.push(ProfileDocumentPattern.fromJS(item));
            }
            this.avatarUrl = data["avatarUrl"];
            this.name = data["name"];
            this.isDefault = data["isDefault"];
            this.isOracle = data["isOracle"];
            this.userId = data["userId"];
            this.email = data["email"];
            this.isDisplayEmail = data["isDisplayEmail"];
            this.createDate = data["createDate"] ? new Date(data["createDate"].toString()) : <any>undefined;
            this.fullName = data["fullName"];
            this.phoneNumber = data["phoneNumber"];
            this.isDisplayPhoneNumber = data["isDisplayPhoneNumber"];
            this.description = data["description"];
            this.deletedDate = data["deletedDate"] ? new Date(data["deletedDate"].toString()) : <any>undefined;
            this.fingerprint = data["fingerprint"];
            this.user = data["user"] ? User.fromJS(data["user"]) : <any>undefined;
            if(Array.isArray(data["contractors"])) {
                this.contractors = [] as any;
                for (let item of data["contractors"])
                    this.contractors!.push(ProfilesContractor.fromJS(item));
            }
            if(Array.isArray(data["oracles"])) {
                this.oracles = [] as any;
                for (let item of data["oracles"])
                    this.oracles!.push(ProfilesOracle.fromJS(item));
            }
            if(Array.isArray(data["subscribers"])) {
                this.subscribers = [] as any;
                for (let item of data["subscribers"])
                    this.subscribers!.push(Subscription.fromJS(item));
            }
            if(Array.isArray(data["subscriptions"])) {
                this.subscriptions = [] as any;
                for (let item of data["subscriptions"])
                    this.subscriptions!.push(Subscription.fromJS(item));
            }
            if(Array.isArray(data["profilesOracles"])) {
                this.profilesOracles = [] as any;
                for (let item of data["profilesOracles"])
                    this.profilesOracles!.push(ProfilesOracle.fromJS(item));
            }
            if(Array.isArray(data["profilesContractors"])) {
                this.profilesContractors = [] as any;
                for (let item of data["profilesContractors"])
                    this.profilesContractors!.push(ProfilesContractor.fromJS(item));
            }
            if(Array.isArray(data["profileUnconfirmedEmails"])) {
                this.profileUnconfirmedEmails = [] as any;
                for (let item of data["profileUnconfirmedEmails"])
                    this.profileUnconfirmedEmails!.push(ProfileUnconfirmedEmail.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PersonalProfile {
        data = typeof data === 'object' ? data : {};
        let result = new PersonalProfile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["city"] = this.city;
        data["address"] = this.address;
        data["postalCode"] = this.postalCode;
        data["province"] = this.province;
        data["telegram"] = this.telegram;
        data["skype"] = this.skype;
        data["isDisplayCountryId"] = this.isDisplayCountryId;
        data["isDisplayBirthDate"] = this.isDisplayBirthDate;
        data["isDisplayTelegram"] = this.isDisplayTelegram;
        data["isDisplaySkype"] = this.isDisplaySkype;
        data["isDisplayCity"] = this.isDisplayCity;
        data["isDisplayAddress"] = this.isDisplayAddress;
        data["countryId"] = this.countryId;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        if(Array.isArray(this.organizations)) {
            data["organizations"] = [];
            for (let item of this.organizations)
                data["organizations"].push(item.toJSON());
        }
        if(Array.isArray(this.profileDocuments)) {
            data["profileDocuments"] = [];
            for (let item of this.profileDocuments)
                data["profileDocuments"].push(item.toJSON());
        }
        if(Array.isArray(this.profileDocumentPatterns)) {
            data["profileDocumentPatterns"] = [];
            for (let item of this.profileDocumentPatterns)
                data["profileDocumentPatterns"].push(item.toJSON());
        }
        data["avatarUrl"] = this.avatarUrl;
        data["name"] = this.name;
        data["isDefault"] = this.isDefault;
        data["isOracle"] = this.isOracle;
        data["userId"] = this.userId;
        data["email"] = this.email;
        data["isDisplayEmail"] = this.isDisplayEmail;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["fullName"] = this.fullName;
        data["phoneNumber"] = this.phoneNumber;
        data["isDisplayPhoneNumber"] = this.isDisplayPhoneNumber;
        data["description"] = this.description;
        data["deletedDate"] = this.deletedDate ? this.deletedDate.toISOString() : <any>undefined;
        data["fingerprint"] = this.fingerprint;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if(Array.isArray(this.contractors)) {
            data["contractors"] = [];
            for (let item of this.contractors)
                data["contractors"].push(item.toJSON());
        }
        if(Array.isArray(this.oracles)) {
            data["oracles"] = [];
            for (let item of this.oracles)
                data["oracles"].push(item.toJSON());
        }
        if(Array.isArray(this.subscribers)) {
            data["subscribers"] = [];
            for (let item of this.subscribers)
                data["subscribers"].push(item.toJSON());
        }
        if(Array.isArray(this.subscriptions)) {
            data["subscriptions"] = [];
            for (let item of this.subscriptions)
                data["subscriptions"].push(item.toJSON());
        }
        if(Array.isArray(this.profilesOracles)) {
            data["profilesOracles"] = [];
            for (let item of this.profilesOracles)
                data["profilesOracles"].push(item.toJSON());
        }
        if(Array.isArray(this.profilesContractors)) {
            data["profilesContractors"] = [];
            for (let item of this.profilesContractors)
                data["profilesContractors"].push(item.toJSON());
        }
        if(Array.isArray(this.profileUnconfirmedEmails)) {
            data["profileUnconfirmedEmails"] = [];
            for (let item of this.profileUnconfirmedEmails)
                data["profileUnconfirmedEmails"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IPersonalProfile {
    birthDate?: Date | undefined;
    city?: string | undefined;
    address?: string | undefined;
    postalCode?: number | undefined;
    province?: string | undefined;
    telegram?: string | undefined;
    skype?: string | undefined;
    isDisplayCountryId?: boolean | undefined;
    isDisplayBirthDate?: boolean | undefined;
    isDisplayTelegram?: boolean | undefined;
    isDisplaySkype?: boolean | undefined;
    isDisplayCity?: boolean | undefined;
    isDisplayAddress?: boolean | undefined;
    countryId?: number | undefined;
    country?: Country | undefined;
    organizations?: OrganizationAgent[] | undefined;
    profileDocuments?: ProfileDocument[] | undefined;
    profileDocumentPatterns?: ProfileDocumentPattern[] | undefined;
    avatarUrl?: string | undefined;
    name?: string | undefined;
    isDefault?: boolean | undefined;
    isOracle?: boolean | undefined;
    userId?: string | undefined;
    email?: string | undefined;
    isDisplayEmail?: boolean | undefined;
    createDate?: Date | undefined;
    fullName?: string | undefined;
    phoneNumber?: string | undefined;
    isDisplayPhoneNumber?: boolean | undefined;
    description?: string | undefined;
    deletedDate?: Date | undefined;
    fingerprint?: string | undefined;
    user?: User | undefined;
    contractors?: ProfilesContractor[] | undefined;
    oracles?: ProfilesOracle[] | undefined;
    subscribers?: Subscription[] | undefined;
    subscriptions?: Subscription[] | undefined;
    profilesOracles?: ProfilesOracle[] | undefined;
    profilesContractors?: ProfilesContractor[] | undefined;
    profileUnconfirmedEmails?: ProfileUnconfirmedEmail[] | undefined;
    id?: number | undefined;
}

export class CountryDocumentField implements ICountryDocumentField {
    countryId?: number | undefined;
    documentType?: CountryDocumentFieldDocumentType | undefined;
    controlName?: string | undefined;
    mask?: string | undefined;
    show?: boolean | undefined;
    country?: Country | undefined;
    id?: number | undefined;

    constructor(data?: ICountryDocumentField) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if(data) {
            this.countryId = data["countryId"];
            this.documentType = data["documentType"];
            this.controlName = data["controlName"];
            this.mask = data["mask"];
            this.show = data["show"];
            this.country = data["country"] ? Country.fromJS(data["country"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CountryDocumentField {
        data = typeof data === 'object' ? data : {};
        let result = new CountryDocumentField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryId"] = this.countryId;
        data["documentType"] = this.documentType;
        data["controlName"] = this.controlName;
        data["mask"] = this.mask;
        data["show"] = this.show;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ICountryDocumentField {
    countryId?: number | undefined;
    documentType?: CountryDocumentFieldDocumentType | undefined;
    controlName?: string | undefined;
    mask?: string | undefined;
    show?: boolean | undefined;
    country?: Country | undefined;
    id?: number | undefined;
}

export class ProfileDocument implements IProfileDocument {
    profileId?: number | undefined;
    countryId?: number | undefined;
    documentType?: ProfileDocumentDocumentType | undefined;
    documentNumber?: string | undefined;
    documentSurname?: string | undefined;
    documentName?: string | undefined;
    documentBirthDate?: Date | undefined;
    documentIssuedDate?: Date | undefined;
    documentAuthority?: string | undefined;
    documentExpiryDate?: Date | undefined;
    documentBirthPlace?: string | undefined;
    documentNationality?: string | undefined;
    documentSex?: string | undefined;
    documentAddress?: string | undefined;
    documentPersonalNumber?: string | undefined;
    documentHeight?: string | undefined;
    documentCharType?: string | undefined;
    documentCountryCode?: string | undefined;
    documentResidence?: string | undefined;
    documentCardName?: string | undefined;
    documentReligion?: string | undefined;
    documentCardAdministrative?: string | undefined;
    documentCardPIN?: string | undefined;
    documentStartDate?: Date | undefined;
    driverLicenseCategory?: string | undefined;
    driverAlamat?: string | undefined;
    driverTempat?: string | undefined;
    driverPekerjaan?: string | undefined;
    driverSIM?: string | undefined;
    driverBerlaku?: string | undefined;
    driverProvinceCode?: string | undefined;
    driverPlaceRegistration?: string | undefined;
    driverDateRegistration?: Date | undefined;
    driverHeadquarter?: string | undefined;
    driverConditions?: string | undefined;
    driverClass?: string | undefined;
    isDisplayDocument?: boolean | undefined;
    deletedDate?: Date | undefined;
    country?: Country | undefined;
    profile?: PersonalProfile | undefined;
    id?: number | undefined;

    constructor(data?: IProfileDocument) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if(data) {
            this.profileId = data["profileId"];
            this.countryId = data["countryId"];
            this.documentType = data["documentType"];
            this.documentNumber = data["documentNumber"];
            this.documentSurname = data["documentSurname"];
            this.documentName = data["documentName"];
            this.documentBirthDate = data["documentBirthDate"] ? new Date(data["documentBirthDate"].toString()) : <any>undefined;
            this.documentIssuedDate = data["documentIssuedDate"] ? new Date(data["documentIssuedDate"].toString()) : <any>undefined;
            this.documentAuthority = data["documentAuthority"];
            this.documentExpiryDate = data["documentExpiryDate"] ? new Date(data["documentExpiryDate"].toString()) : <any>undefined;
            this.documentBirthPlace = data["documentBirthPlace"];
            this.documentNationality = data["documentNationality"];
            this.documentSex = data["documentSex"];
            this.documentAddress = data["documentAddress"];
            this.documentPersonalNumber = data["documentPersonalNumber"];
            this.documentHeight = data["documentHeight"];
            this.documentCharType = data["documentCharType"];
            this.documentCountryCode = data["documentCountryCode"];
            this.documentResidence = data["documentResidence"];
            this.documentCardName = data["documentCardName"];
            this.documentReligion = data["documentReligion"];
            this.documentCardAdministrative = data["documentCardAdministrative"];
            this.documentCardPIN = data["documentCardPIN"];
            this.documentStartDate = data["documentStartDate"] ? new Date(data["documentStartDate"].toString()) : <any>undefined;
            this.driverLicenseCategory = data["driverLicenseCategory"];
            this.driverAlamat = data["driverAlamat"];
            this.driverTempat = data["driverTempat"];
            this.driverPekerjaan = data["driverPekerjaan"];
            this.driverSIM = data["driverSIM"];
            this.driverBerlaku = data["driverBerlaku"];
            this.driverProvinceCode = data["driverProvinceCode"];
            this.driverPlaceRegistration = data["driverPlaceRegistration"];
            this.driverDateRegistration = data["driverDateRegistration"] ? new Date(data["driverDateRegistration"].toString()) : <any>undefined;
            this.driverHeadquarter = data["driverHeadquarter"];
            this.driverConditions = data["driverConditions"];
            this.driverClass = data["driverClass"];
            this.isDisplayDocument = data["isDisplayDocument"];
            this.deletedDate = data["deletedDate"] ? new Date(data["deletedDate"].toString()) : <any>undefined;
            this.country = data["country"] ? Country.fromJS(data["country"]) : <any>undefined;
            this.profile = data["profile"] ? PersonalProfile.fromJS(data["profile"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ProfileDocument {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profileId"] = this.profileId;
        data["countryId"] = this.countryId;
        data["documentType"] = this.documentType;
        data["documentNumber"] = this.documentNumber;
        data["documentSurname"] = this.documentSurname;
        data["documentName"] = this.documentName;
        data["documentBirthDate"] = this.documentBirthDate ? this.documentBirthDate.toISOString() : <any>undefined;
        data["documentIssuedDate"] = this.documentIssuedDate ? this.documentIssuedDate.toISOString() : <any>undefined;
        data["documentAuthority"] = this.documentAuthority;
        data["documentExpiryDate"] = this.documentExpiryDate ? this.documentExpiryDate.toISOString() : <any>undefined;
        data["documentBirthPlace"] = this.documentBirthPlace;
        data["documentNationality"] = this.documentNationality;
        data["documentSex"] = this.documentSex;
        data["documentAddress"] = this.documentAddress;
        data["documentPersonalNumber"] = this.documentPersonalNumber;
        data["documentHeight"] = this.documentHeight;
        data["documentCharType"] = this.documentCharType;
        data["documentCountryCode"] = this.documentCountryCode;
        data["documentResidence"] = this.documentResidence;
        data["documentCardName"] = this.documentCardName;
        data["documentReligion"] = this.documentReligion;
        data["documentCardAdministrative"] = this.documentCardAdministrative;
        data["documentCardPIN"] = this.documentCardPIN;
        data["documentStartDate"] = this.documentStartDate ? this.documentStartDate.toISOString() : <any>undefined;
        data["driverLicenseCategory"] = this.driverLicenseCategory;
        data["driverAlamat"] = this.driverAlamat;
        data["driverTempat"] = this.driverTempat;
        data["driverPekerjaan"] = this.driverPekerjaan;
        data["driverSIM"] = this.driverSIM;
        data["driverBerlaku"] = this.driverBerlaku;
        data["driverProvinceCode"] = this.driverProvinceCode;
        data["driverPlaceRegistration"] = this.driverPlaceRegistration;
        data["driverDateRegistration"] = this.driverDateRegistration ? this.driverDateRegistration.toISOString() : <any>undefined;
        data["driverHeadquarter"] = this.driverHeadquarter;
        data["driverConditions"] = this.driverConditions;
        data["driverClass"] = this.driverClass;
        data["isDisplayDocument"] = this.isDisplayDocument;
        data["deletedDate"] = this.deletedDate ? this.deletedDate.toISOString() : <any>undefined;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["profile"] = this.profile ? this.profile.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IProfileDocument {
    profileId?: number | undefined;
    countryId?: number | undefined;
    documentType?: ProfileDocumentDocumentType | undefined;
    documentNumber?: string | undefined;
    documentSurname?: string | undefined;
    documentName?: string | undefined;
    documentBirthDate?: Date | undefined;
    documentIssuedDate?: Date | undefined;
    documentAuthority?: string | undefined;
    documentExpiryDate?: Date | undefined;
    documentBirthPlace?: string | undefined;
    documentNationality?: string | undefined;
    documentSex?: string | undefined;
    documentAddress?: string | undefined;
    documentPersonalNumber?: string | undefined;
    documentHeight?: string | undefined;
    documentCharType?: string | undefined;
    documentCountryCode?: string | undefined;
    documentResidence?: string | undefined;
    documentCardName?: string | undefined;
    documentReligion?: string | undefined;
    documentCardAdministrative?: string | undefined;
    documentCardPIN?: string | undefined;
    documentStartDate?: Date | undefined;
    driverLicenseCategory?: string | undefined;
    driverAlamat?: string | undefined;
    driverTempat?: string | undefined;
    driverPekerjaan?: string | undefined;
    driverSIM?: string | undefined;
    driverBerlaku?: string | undefined;
    driverProvinceCode?: string | undefined;
    driverPlaceRegistration?: string | undefined;
    driverDateRegistration?: Date | undefined;
    driverHeadquarter?: string | undefined;
    driverConditions?: string | undefined;
    driverClass?: string | undefined;
    isDisplayDocument?: boolean | undefined;
    deletedDate?: Date | undefined;
    country?: Country | undefined;
    profile?: PersonalProfile | undefined;
    id?: number | undefined;
}

export class OrganizationAgent implements IOrganizationAgent {
    organizationProfileId?: number | undefined;
    personalProfileId?: number | undefined;
    bindDateTime?: Date | undefined;
    acceptedDateTime?: Date | undefined;
    requestType?: OrganizationAgentRequestType | undefined;
    organizationProfile?: OrganizationProfile | undefined;
    personalProfile?: PersonalProfile | undefined;
    id?: number | undefined;

    constructor(data?: IOrganizationAgent) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if(data) {
            this.organizationProfileId = data["organizationProfileId"];
            this.personalProfileId = data["personalProfileId"];
            this.bindDateTime = data["bindDateTime"] ? new Date(data["bindDateTime"].toString()) : <any>undefined;
            this.acceptedDateTime = data["acceptedDateTime"] ? new Date(data["acceptedDateTime"].toString()) : <any>undefined;
            this.requestType = data["requestType"];
            this.organizationProfile = data["organizationProfile"] ? OrganizationProfile.fromJS(data["organizationProfile"]) : <any>undefined;
            this.personalProfile = data["personalProfile"] ? PersonalProfile.fromJS(data["personalProfile"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): OrganizationAgent {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationAgent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationProfileId"] = this.organizationProfileId;
        data["personalProfileId"] = this.personalProfileId;
        data["bindDateTime"] = this.bindDateTime ? this.bindDateTime.toISOString() : <any>undefined;
        data["acceptedDateTime"] = this.acceptedDateTime ? this.acceptedDateTime.toISOString() : <any>undefined;
        data["requestType"] = this.requestType;
        data["organizationProfile"] = this.organizationProfile ? this.organizationProfile.toJSON() : <any>undefined;
        data["personalProfile"] = this.personalProfile ? this.personalProfile.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IOrganizationAgent {
    organizationProfileId?: number | undefined;
    personalProfileId?: number | undefined;
    bindDateTime?: Date | undefined;
    acceptedDateTime?: Date | undefined;
    requestType?: OrganizationAgentRequestType | undefined;
    organizationProfile?: OrganizationProfile | undefined;
    personalProfile?: PersonalProfile | undefined;
    id?: number | undefined;
}

export class ProfileDocumentPattern implements IProfileDocumentPattern {
    profileId?: number | undefined;
    name?: string | undefined;
    description?: string | undefined;
    createDate?: Date | undefined;
    deletedDate?: Date | undefined;
    profile?: Profile | undefined;
    id?: number | undefined;

    constructor(data?: IProfileDocumentPattern) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if(data) {
            this.profileId = data["profileId"];
            this.name = data["name"];
            this.description = data["description"];
            this.createDate = data["createDate"] ? new Date(data["createDate"].toString()) : <any>undefined;
            this.deletedDate = data["deletedDate"] ? new Date(data["deletedDate"].toString()) : <any>undefined;
            this.profile = data["profile"] ? Profile.fromJS(data["profile"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ProfileDocumentPattern {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileDocumentPattern();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profileId"] = this.profileId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["deletedDate"] = this.deletedDate ? this.deletedDate.toISOString() : <any>undefined;
        data["profile"] = this.profile ? this.profile.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IProfileDocumentPattern {
    profileId?: number | undefined;
    name?: string | undefined;
    description?: string | undefined;
    createDate?: Date | undefined;
    deletedDate?: Date | undefined;
    profile?: Profile | undefined;
    id?: number | undefined;
}

export class User implements IUser {
    firstName?: string | undefined;
    lastName?: string | undefined;
    salt?: string | undefined;
    accountType?: UserAccountType | undefined;
    googleId?: string | undefined;
    facebookId?: string | undefined;
    linkedinId?: string | undefined;
    telegramId?: string | undefined;
    passwordChangeDate?: Date | undefined;
    profiles?: Profile[] | undefined;
    userUnconfirmedEmails?: UserUnconfirmedEmail[] | undefined;
    id?: string | undefined;
    userName?: string | undefined;
    normalizedUserName?: string | undefined;
    email?: string | undefined;
    normalizedEmail?: string | undefined;
    emailConfirmed?: boolean | undefined;
    passwordHash?: string | undefined;
    securityStamp?: string | undefined;
    concurrencyStamp?: string | undefined;
    phoneNumber?: string | undefined;
    phoneNumberConfirmed?: boolean | undefined;
    twoFactorEnabled?: boolean | undefined;
    lockoutEnd?: Date | undefined;
    lockoutEnabled?: boolean | undefined;
    accessFailedCount?: number | undefined;

    constructor(data?: IUser) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if(data) {
            this.firstName = data["firstName"];
            this.lastName = data["lastName"];
            this.salt = data["salt"];
            this.accountType = data["accountType"];
            this.googleId = data["googleId"];
            this.facebookId = data["facebookId"];
            this.linkedinId = data["linkedinId"];
            this.telegramId = data["telegramId"];
            this.passwordChangeDate = data["passwordChangeDate"] ? new Date(data["passwordChangeDate"].toString()) : <any>undefined;
            if(Array.isArray(data["profiles"])) {
                this.profiles = [] as any;
                for (let item of data["profiles"])
                    this.profiles!.push(Profile.fromJS(item));
            }
            if(Array.isArray(data["userUnconfirmedEmails"])) {
                this.userUnconfirmedEmails = [] as any;
                for (let item of data["userUnconfirmedEmails"])
                    this.userUnconfirmedEmails!.push(UserUnconfirmedEmail.fromJS(item));
            }
            this.id = data["id"];
            this.userName = data["userName"];
            this.normalizedUserName = data["normalizedUserName"];
            this.email = data["email"];
            this.normalizedEmail = data["normalizedEmail"];
            this.emailConfirmed = data["emailConfirmed"];
            this.passwordHash = data["passwordHash"];
            this.securityStamp = data["securityStamp"];
            this.concurrencyStamp = data["concurrencyStamp"];
            this.phoneNumber = data["phoneNumber"];
            this.phoneNumberConfirmed = data["phoneNumberConfirmed"];
            this.twoFactorEnabled = data["twoFactorEnabled"];
            this.lockoutEnd = data["lockoutEnd"] ? new Date(data["lockoutEnd"].toString()) : <any>undefined;
            this.lockoutEnabled = data["lockoutEnabled"];
            this.accessFailedCount = data["accessFailedCount"];
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["salt"] = this.salt;
        data["accountType"] = this.accountType;
        data["googleId"] = this.googleId;
        data["facebookId"] = this.facebookId;
        data["linkedinId"] = this.linkedinId;
        data["telegramId"] = this.telegramId;
        data["passwordChangeDate"] = this.passwordChangeDate ? this.passwordChangeDate.toISOString() : <any>undefined;
        if(Array.isArray(this.profiles)) {
            data["profiles"] = [];
            for (let item of this.profiles)
                data["profiles"].push(item.toJSON());
        }
        if(Array.isArray(this.userUnconfirmedEmails)) {
            data["userUnconfirmedEmails"] = [];
            for (let item of this.userUnconfirmedEmails)
                data["userUnconfirmedEmails"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["normalizedUserName"] = this.normalizedUserName;
        data["email"] = this.email;
        data["normalizedEmail"] = this.normalizedEmail;
        data["emailConfirmed"] = this.emailConfirmed;
        data["passwordHash"] = this.passwordHash;
        data["securityStamp"] = this.securityStamp;
        data["concurrencyStamp"] = this.concurrencyStamp;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneNumberConfirmed"] = this.phoneNumberConfirmed;
        data["twoFactorEnabled"] = this.twoFactorEnabled;
        data["lockoutEnd"] = this.lockoutEnd ? this.lockoutEnd.toISOString() : <any>undefined;
        data["lockoutEnabled"] = this.lockoutEnabled;
        data["accessFailedCount"] = this.accessFailedCount;
        return data;
    }
}

export interface IUser {
    firstName?: string | undefined;
    lastName?: string | undefined;
    salt?: string | undefined;
    accountType?: UserAccountType | undefined;
    googleId?: string | undefined;
    facebookId?: string | undefined;
    linkedinId?: string | undefined;
    telegramId?: string | undefined;
    passwordChangeDate?: Date | undefined;
    profiles?: Profile[] | undefined;
    userUnconfirmedEmails?: UserUnconfirmedEmail[] | undefined;
    id?: string | undefined;
    userName?: string | undefined;
    normalizedUserName?: string | undefined;
    email?: string | undefined;
    normalizedEmail?: string | undefined;
    emailConfirmed?: boolean | undefined;
    passwordHash?: string | undefined;
    securityStamp?: string | undefined;
    concurrencyStamp?: string | undefined;
    phoneNumber?: string | undefined;
    phoneNumberConfirmed?: boolean | undefined;
    twoFactorEnabled?: boolean | undefined;
    lockoutEnd?: Date | undefined;
    lockoutEnabled?: boolean | undefined;
    accessFailedCount?: number | undefined;
}

export class ProfilesContractor implements IProfilesContractor {
    profileId?: number | undefined;
    contractorProfileId?: number | undefined;
    createDate?: Date | undefined;
    deleteDate?: Date | undefined;
    profile?: Profile | undefined;
    contractorProfile?: Profile | undefined;
    id?: number | undefined;

    constructor(data?: IProfilesContractor) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if(data) {
            this.profileId = data["profileId"];
            this.contractorProfileId = data["contractorProfileId"];
            this.createDate = data["createDate"] ? new Date(data["createDate"].toString()) : <any>undefined;
            this.deleteDate = data["deleteDate"] ? new Date(data["deleteDate"].toString()) : <any>undefined;
            this.profile = data["profile"] ? Profile.fromJS(data["profile"]) : <any>undefined;
            this.contractorProfile = data["contractorProfile"] ? Profile.fromJS(data["contractorProfile"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ProfilesContractor {
        data = typeof data === 'object' ? data : {};
        let result = new ProfilesContractor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profileId"] = this.profileId;
        data["contractorProfileId"] = this.contractorProfileId;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["deleteDate"] = this.deleteDate ? this.deleteDate.toISOString() : <any>undefined;
        data["profile"] = this.profile ? this.profile.toJSON() : <any>undefined;
        data["contractorProfile"] = this.contractorProfile ? this.contractorProfile.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IProfilesContractor {
    profileId?: number | undefined;
    contractorProfileId?: number | undefined;
    createDate?: Date | undefined;
    deleteDate?: Date | undefined;
    profile?: Profile | undefined;
    contractorProfile?: Profile | undefined;
    id?: number | undefined;
}

export class ProfilesOracle implements IProfilesOracle {
    profileId?: number | undefined;
    oracleProfileId?: number | undefined;
    createDate?: Date | undefined;
    deleteDate?: Date | undefined;
    profile?: Profile | undefined;
    oracleProfile?: Profile | undefined;
    id?: number | undefined;

    constructor(data?: IProfilesOracle) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if(data) {
            this.profileId = data["profileId"];
            this.oracleProfileId = data["oracleProfileId"];
            this.createDate = data["createDate"] ? new Date(data["createDate"].toString()) : <any>undefined;
            this.deleteDate = data["deleteDate"] ? new Date(data["deleteDate"].toString()) : <any>undefined;
            this.profile = data["profile"] ? Profile.fromJS(data["profile"]) : <any>undefined;
            this.oracleProfile = data["oracleProfile"] ? Profile.fromJS(data["oracleProfile"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ProfilesOracle {
        data = typeof data === 'object' ? data : {};
        let result = new ProfilesOracle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profileId"] = this.profileId;
        data["oracleProfileId"] = this.oracleProfileId;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["deleteDate"] = this.deleteDate ? this.deleteDate.toISOString() : <any>undefined;
        data["profile"] = this.profile ? this.profile.toJSON() : <any>undefined;
        data["oracleProfile"] = this.oracleProfile ? this.oracleProfile.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IProfilesOracle {
    profileId?: number | undefined;
    oracleProfileId?: number | undefined;
    createDate?: Date | undefined;
    deleteDate?: Date | undefined;
    profile?: Profile | undefined;
    oracleProfile?: Profile | undefined;
    id?: number | undefined;
}

export class Subscription implements ISubscription {
    profileId?: number | undefined;
    subscriptionProfileId?: number | undefined;
    subscribeDateTime?: Date | undefined;
    profile?: Profile | undefined;
    subscriptionProfile?: Profile | undefined;
    id?: number | undefined;

    constructor(data?: ISubscription) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if(data) {
            this.profileId = data["profileId"];
            this.subscriptionProfileId = data["subscriptionProfileId"];
            this.subscribeDateTime = data["subscribeDateTime"] ? new Date(data["subscribeDateTime"].toString()) : <any>undefined;
            this.profile = data["profile"] ? Profile.fromJS(data["profile"]) : <any>undefined;
            this.subscriptionProfile = data["subscriptionProfile"] ? Profile.fromJS(data["subscriptionProfile"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): Subscription {
        data = typeof data === 'object' ? data : {};
        let result = new Subscription();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profileId"] = this.profileId;
        data["subscriptionProfileId"] = this.subscriptionProfileId;
        data["subscribeDateTime"] = this.subscribeDateTime ? this.subscribeDateTime.toISOString() : <any>undefined;
        data["profile"] = this.profile ? this.profile.toJSON() : <any>undefined;
        data["subscriptionProfile"] = this.subscriptionProfile ? this.subscriptionProfile.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ISubscription {
    profileId?: number | undefined;
    subscriptionProfileId?: number | undefined;
    subscribeDateTime?: Date | undefined;
    profile?: Profile | undefined;
    subscriptionProfile?: Profile | undefined;
    id?: number | undefined;
}

export class ProfileUnconfirmedEmail implements IProfileUnconfirmedEmail {
    profileId?: number | undefined;
    newEmail?: string | undefined;
    confirmationCode?: string | undefined;
    expiredCodeDate?: Date | undefined;
    isNewProfile?: boolean | undefined;
    profile?: Profile | undefined;
    id?: number | undefined;

    constructor(data?: IProfileUnconfirmedEmail) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if(data) {
            this.profileId = data["profileId"];
            this.newEmail = data["newEmail"];
            this.confirmationCode = data["confirmationCode"];
            this.expiredCodeDate = data["expiredCodeDate"] ? new Date(data["expiredCodeDate"].toString()) : <any>undefined;
            this.isNewProfile = data["isNewProfile"];
            this.profile = data["profile"] ? Profile.fromJS(data["profile"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ProfileUnconfirmedEmail {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileUnconfirmedEmail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profileId"] = this.profileId;
        data["newEmail"] = this.newEmail;
        data["confirmationCode"] = this.confirmationCode;
        data["expiredCodeDate"] = this.expiredCodeDate ? this.expiredCodeDate.toISOString() : <any>undefined;
        data["isNewProfile"] = this.isNewProfile;
        data["profile"] = this.profile ? this.profile.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IProfileUnconfirmedEmail {
    profileId?: number | undefined;
    newEmail?: string | undefined;
    confirmationCode?: string | undefined;
    expiredCodeDate?: Date | undefined;
    isNewProfile?: boolean | undefined;
    profile?: Profile | undefined;
    id?: number | undefined;
}

export class OrganizationProfile implements IOrganizationProfile {
    typeOrganization?: string | undefined;
    tin?: string | undefined;
    phoneCompany?: string | undefined;
    registrationAddress?: string | undefined;
    psrn?: string | undefined;
    license?: string | undefined;
    isDisplayTypeOrganization?: boolean | undefined;
    isDisplayTin?: boolean | undefined;
    isDisplayPhoneCompany?: boolean | undefined;
    isDisplayRegistrationAddress?: boolean | undefined;
    isDisplayPsrn?: boolean | undefined;
    isDisplayLicense?: boolean | undefined;
    agents?: OrganizationAgent[] | undefined;
    avatarUrl?: string | undefined;
    name?: string | undefined;
    isDefault?: boolean | undefined;
    isOracle?: boolean | undefined;
    userId?: string | undefined;
    email?: string | undefined;
    isDisplayEmail?: boolean | undefined;
    createDate?: Date | undefined;
    fullName?: string | undefined;
    phoneNumber?: string | undefined;
    isDisplayPhoneNumber?: boolean | undefined;
    description?: string | undefined;
    deletedDate?: Date | undefined;
    fingerprint?: string | undefined;
    user?: User | undefined;
    contractors?: ProfilesContractor[] | undefined;
    oracles?: ProfilesOracle[] | undefined;
    subscribers?: Subscription[] | undefined;
    subscriptions?: Subscription[] | undefined;
    profilesOracles?: ProfilesOracle[] | undefined;
    profilesContractors?: ProfilesContractor[] | undefined;
    profileUnconfirmedEmails?: ProfileUnconfirmedEmail[] | undefined;
    id?: number | undefined;

    constructor(data?: IOrganizationProfile) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if(data) {
            this.typeOrganization = data["typeOrganization"];
            this.tin = data["tin"];
            this.phoneCompany = data["phoneCompany"];
            this.registrationAddress = data["registrationAddress"];
            this.psrn = data["psrn"];
            this.license = data["license"];
            this.isDisplayTypeOrganization = data["isDisplayTypeOrganization"];
            this.isDisplayTin = data["isDisplayTin"];
            this.isDisplayPhoneCompany = data["isDisplayPhoneCompany"];
            this.isDisplayRegistrationAddress = data["isDisplayRegistrationAddress"];
            this.isDisplayPsrn = data["isDisplayPsrn"];
            this.isDisplayLicense = data["isDisplayLicense"];
            if(Array.isArray(data["agents"])) {
                this.agents = [] as any;
                for (let item of data["agents"])
                    this.agents!.push(OrganizationAgent.fromJS(item));
            }
            this.avatarUrl = data["avatarUrl"];
            this.name = data["name"];
            this.isDefault = data["isDefault"];
            this.isOracle = data["isOracle"];
            this.userId = data["userId"];
            this.email = data["email"];
            this.isDisplayEmail = data["isDisplayEmail"];
            this.createDate = data["createDate"] ? new Date(data["createDate"].toString()) : <any>undefined;
            this.fullName = data["fullName"];
            this.phoneNumber = data["phoneNumber"];
            this.isDisplayPhoneNumber = data["isDisplayPhoneNumber"];
            this.description = data["description"];
            this.deletedDate = data["deletedDate"] ? new Date(data["deletedDate"].toString()) : <any>undefined;
            this.fingerprint = data["fingerprint"];
            this.user = data["user"] ? User.fromJS(data["user"]) : <any>undefined;
            if(Array.isArray(data["contractors"])) {
                this.contractors = [] as any;
                for (let item of data["contractors"])
                    this.contractors!.push(ProfilesContractor.fromJS(item));
            }
            if(Array.isArray(data["oracles"])) {
                this.oracles = [] as any;
                for (let item of data["oracles"])
                    this.oracles!.push(ProfilesOracle.fromJS(item));
            }
            if(Array.isArray(data["subscribers"])) {
                this.subscribers = [] as any;
                for (let item of data["subscribers"])
                    this.subscribers!.push(Subscription.fromJS(item));
            }
            if(Array.isArray(data["subscriptions"])) {
                this.subscriptions = [] as any;
                for (let item of data["subscriptions"])
                    this.subscriptions!.push(Subscription.fromJS(item));
            }
            if(Array.isArray(data["profilesOracles"])) {
                this.profilesOracles = [] as any;
                for (let item of data["profilesOracles"])
                    this.profilesOracles!.push(ProfilesOracle.fromJS(item));
            }
            if(Array.isArray(data["profilesContractors"])) {
                this.profilesContractors = [] as any;
                for (let item of data["profilesContractors"])
                    this.profilesContractors!.push(ProfilesContractor.fromJS(item));
            }
            if(Array.isArray(data["profileUnconfirmedEmails"])) {
                this.profileUnconfirmedEmails = [] as any;
                for (let item of data["profileUnconfirmedEmails"])
                    this.profileUnconfirmedEmails!.push(ProfileUnconfirmedEmail.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): OrganizationProfile {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationProfile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeOrganization"] = this.typeOrganization;
        data["tin"] = this.tin;
        data["phoneCompany"] = this.phoneCompany;
        data["registrationAddress"] = this.registrationAddress;
        data["psrn"] = this.psrn;
        data["license"] = this.license;
        data["isDisplayTypeOrganization"] = this.isDisplayTypeOrganization;
        data["isDisplayTin"] = this.isDisplayTin;
        data["isDisplayPhoneCompany"] = this.isDisplayPhoneCompany;
        data["isDisplayRegistrationAddress"] = this.isDisplayRegistrationAddress;
        data["isDisplayPsrn"] = this.isDisplayPsrn;
        data["isDisplayLicense"] = this.isDisplayLicense;
        if(Array.isArray(this.agents)) {
            data["agents"] = [];
            for (let item of this.agents)
                data["agents"].push(item.toJSON());
        }
        data["avatarUrl"] = this.avatarUrl;
        data["name"] = this.name;
        data["isDefault"] = this.isDefault;
        data["isOracle"] = this.isOracle;
        data["userId"] = this.userId;
        data["email"] = this.email;
        data["isDisplayEmail"] = this.isDisplayEmail;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["fullName"] = this.fullName;
        data["phoneNumber"] = this.phoneNumber;
        data["isDisplayPhoneNumber"] = this.isDisplayPhoneNumber;
        data["description"] = this.description;
        data["deletedDate"] = this.deletedDate ? this.deletedDate.toISOString() : <any>undefined;
        data["fingerprint"] = this.fingerprint;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if(Array.isArray(this.contractors)) {
            data["contractors"] = [];
            for (let item of this.contractors)
                data["contractors"].push(item.toJSON());
        }
        if(Array.isArray(this.oracles)) {
            data["oracles"] = [];
            for (let item of this.oracles)
                data["oracles"].push(item.toJSON());
        }
        if(Array.isArray(this.subscribers)) {
            data["subscribers"] = [];
            for (let item of this.subscribers)
                data["subscribers"].push(item.toJSON());
        }
        if(Array.isArray(this.subscriptions)) {
            data["subscriptions"] = [];
            for (let item of this.subscriptions)
                data["subscriptions"].push(item.toJSON());
        }
        if(Array.isArray(this.profilesOracles)) {
            data["profilesOracles"] = [];
            for (let item of this.profilesOracles)
                data["profilesOracles"].push(item.toJSON());
        }
        if(Array.isArray(this.profilesContractors)) {
            data["profilesContractors"] = [];
            for (let item of this.profilesContractors)
                data["profilesContractors"].push(item.toJSON());
        }
        if(Array.isArray(this.profileUnconfirmedEmails)) {
            data["profileUnconfirmedEmails"] = [];
            for (let item of this.profileUnconfirmedEmails)
                data["profileUnconfirmedEmails"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IOrganizationProfile {
    typeOrganization?: string | undefined;
    tin?: string | undefined;
    phoneCompany?: string | undefined;
    registrationAddress?: string | undefined;
    psrn?: string | undefined;
    license?: string | undefined;
    isDisplayTypeOrganization?: boolean | undefined;
    isDisplayTin?: boolean | undefined;
    isDisplayPhoneCompany?: boolean | undefined;
    isDisplayRegistrationAddress?: boolean | undefined;
    isDisplayPsrn?: boolean | undefined;
    isDisplayLicense?: boolean | undefined;
    agents?: OrganizationAgent[] | undefined;
    avatarUrl?: string | undefined;
    name?: string | undefined;
    isDefault?: boolean | undefined;
    isOracle?: boolean | undefined;
    userId?: string | undefined;
    email?: string | undefined;
    isDisplayEmail?: boolean | undefined;
    createDate?: Date | undefined;
    fullName?: string | undefined;
    phoneNumber?: string | undefined;
    isDisplayPhoneNumber?: boolean | undefined;
    description?: string | undefined;
    deletedDate?: Date | undefined;
    fingerprint?: string | undefined;
    user?: User | undefined;
    contractors?: ProfilesContractor[] | undefined;
    oracles?: ProfilesOracle[] | undefined;
    subscribers?: Subscription[] | undefined;
    subscriptions?: Subscription[] | undefined;
    profilesOracles?: ProfilesOracle[] | undefined;
    profilesContractors?: ProfilesContractor[] | undefined;
    profileUnconfirmedEmails?: ProfileUnconfirmedEmail[] | undefined;
    id?: number | undefined;
}

export class Profile implements IProfile {
    avatarUrl?: string | undefined;
    name?: string | undefined;
    isDefault?: boolean | undefined;
    isOracle?: boolean | undefined;
    userId?: string | undefined;
    email?: string | undefined;
    isDisplayEmail?: boolean | undefined;
    createDate?: Date | undefined;
    fullName?: string | undefined;
    phoneNumber?: string | undefined;
    isDisplayPhoneNumber?: boolean | undefined;
    description?: string | undefined;
    deletedDate?: Date | undefined;
    fingerprint?: string | undefined;
    user?: User | undefined;
    contractors?: ProfilesContractor[] | undefined;
    oracles?: ProfilesOracle[] | undefined;
    subscribers?: Subscription[] | undefined;
    subscriptions?: Subscription[] | undefined;
    profilesOracles?: ProfilesOracle[] | undefined;
    profilesContractors?: ProfilesContractor[] | undefined;
    profileUnconfirmedEmails?: ProfileUnconfirmedEmail[] | undefined;
    id?: number | undefined;

    constructor(data?: IProfile) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if(data) {
            this.avatarUrl = data["avatarUrl"];
            this.name = data["name"];
            this.isDefault = data["isDefault"];
            this.isOracle = data["isOracle"];
            this.userId = data["userId"];
            this.email = data["email"];
            this.isDisplayEmail = data["isDisplayEmail"];
            this.createDate = data["createDate"] ? new Date(data["createDate"].toString()) : <any>undefined;
            this.fullName = data["fullName"];
            this.phoneNumber = data["phoneNumber"];
            this.isDisplayPhoneNumber = data["isDisplayPhoneNumber"];
            this.description = data["description"];
            this.deletedDate = data["deletedDate"] ? new Date(data["deletedDate"].toString()) : <any>undefined;
            this.fingerprint = data["fingerprint"];
            this.user = data["user"] ? User.fromJS(data["user"]) : <any>undefined;
            if(Array.isArray(data["contractors"])) {
                this.contractors = [] as any;
                for (let item of data["contractors"])
                    this.contractors!.push(ProfilesContractor.fromJS(item));
            }
            if(Array.isArray(data["oracles"])) {
                this.oracles = [] as any;
                for (let item of data["oracles"])
                    this.oracles!.push(ProfilesOracle.fromJS(item));
            }
            if(Array.isArray(data["subscribers"])) {
                this.subscribers = [] as any;
                for (let item of data["subscribers"])
                    this.subscribers!.push(Subscription.fromJS(item));
            }
            if(Array.isArray(data["subscriptions"])) {
                this.subscriptions = [] as any;
                for (let item of data["subscriptions"])
                    this.subscriptions!.push(Subscription.fromJS(item));
            }
            if(Array.isArray(data["profilesOracles"])) {
                this.profilesOracles = [] as any;
                for (let item of data["profilesOracles"])
                    this.profilesOracles!.push(ProfilesOracle.fromJS(item));
            }
            if(Array.isArray(data["profilesContractors"])) {
                this.profilesContractors = [] as any;
                for (let item of data["profilesContractors"])
                    this.profilesContractors!.push(ProfilesContractor.fromJS(item));
            }
            if(Array.isArray(data["profileUnconfirmedEmails"])) {
                this.profileUnconfirmedEmails = [] as any;
                for (let item of data["profileUnconfirmedEmails"])
                    this.profileUnconfirmedEmails!.push(ProfileUnconfirmedEmail.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): Profile {
        data = typeof data === 'object' ? data : {};
        let result = new Profile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["avatarUrl"] = this.avatarUrl;
        data["name"] = this.name;
        data["isDefault"] = this.isDefault;
        data["isOracle"] = this.isOracle;
        data["userId"] = this.userId;
        data["email"] = this.email;
        data["isDisplayEmail"] = this.isDisplayEmail;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["fullName"] = this.fullName;
        data["phoneNumber"] = this.phoneNumber;
        data["isDisplayPhoneNumber"] = this.isDisplayPhoneNumber;
        data["description"] = this.description;
        data["deletedDate"] = this.deletedDate ? this.deletedDate.toISOString() : <any>undefined;
        data["fingerprint"] = this.fingerprint;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if(Array.isArray(this.contractors)) {
            data["contractors"] = [];
            for (let item of this.contractors)
                data["contractors"].push(item.toJSON());
        }
        if(Array.isArray(this.oracles)) {
            data["oracles"] = [];
            for (let item of this.oracles)
                data["oracles"].push(item.toJSON());
        }
        if(Array.isArray(this.subscribers)) {
            data["subscribers"] = [];
            for (let item of this.subscribers)
                data["subscribers"].push(item.toJSON());
        }
        if(Array.isArray(this.subscriptions)) {
            data["subscriptions"] = [];
            for (let item of this.subscriptions)
                data["subscriptions"].push(item.toJSON());
        }
        if(Array.isArray(this.profilesOracles)) {
            data["profilesOracles"] = [];
            for (let item of this.profilesOracles)
                data["profilesOracles"].push(item.toJSON());
        }
        if(Array.isArray(this.profilesContractors)) {
            data["profilesContractors"] = [];
            for (let item of this.profilesContractors)
                data["profilesContractors"].push(item.toJSON());
        }
        if(Array.isArray(this.profileUnconfirmedEmails)) {
            data["profileUnconfirmedEmails"] = [];
            for (let item of this.profileUnconfirmedEmails)
                data["profileUnconfirmedEmails"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IProfile {
    avatarUrl?: string | undefined;
    name?: string | undefined;
    isDefault?: boolean | undefined;
    isOracle?: boolean | undefined;
    userId?: string | undefined;
    email?: string | undefined;
    isDisplayEmail?: boolean | undefined;
    createDate?: Date | undefined;
    fullName?: string | undefined;
    phoneNumber?: string | undefined;
    isDisplayPhoneNumber?: boolean | undefined;
    description?: string | undefined;
    deletedDate?: Date | undefined;
    fingerprint?: string | undefined;
    user?: User | undefined;
    contractors?: ProfilesContractor[] | undefined;
    oracles?: ProfilesOracle[] | undefined;
    subscribers?: Subscription[] | undefined;
    subscriptions?: Subscription[] | undefined;
    profilesOracles?: ProfilesOracle[] | undefined;
    profilesContractors?: ProfilesContractor[] | undefined;
    profileUnconfirmedEmails?: ProfileUnconfirmedEmail[] | undefined;
    id?: number | undefined;
}

export class UserUnconfirmedEmail implements IUserUnconfirmedEmail {
    userId?: string | undefined;
    newEmail?: string | undefined;
    confirmationCode?: string | undefined;
    expiredCodeDate?: Date | undefined;
    user?: User | undefined;
    id?: number | undefined;

    constructor(data?: IUserUnconfirmedEmail) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if(data) {
            this.userId = data["userId"];
            this.newEmail = data["newEmail"];
            this.confirmationCode = data["confirmationCode"];
            this.expiredCodeDate = data["expiredCodeDate"] ? new Date(data["expiredCodeDate"].toString()) : <any>undefined;
            this.user = data["user"] ? User.fromJS(data["user"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserUnconfirmedEmail {
        data = typeof data === 'object' ? data : {};
        let result = new UserUnconfirmedEmail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["newEmail"] = this.newEmail;
        data["confirmationCode"] = this.confirmationCode;
        data["expiredCodeDate"] = this.expiredCodeDate ? this.expiredCodeDate.toISOString() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserUnconfirmedEmail {
    userId?: string | undefined;
    newEmail?: string | undefined;
    confirmationCode?: string | undefined;
    expiredCodeDate?: Date | undefined;
    user?: User | undefined;
    id?: number | undefined;
}

export class MultipleQueryResultOfCountryDocumentField implements IMultipleQueryResultOfCountryDocumentField {
    count?: number | undefined;
    data?: CountryDocumentField[] | undefined;

    constructor(data?: IMultipleQueryResultOfCountryDocumentField) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if(data) {
            this.count = data["count"];
            if(Array.isArray(data["data"])) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(CountryDocumentField.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MultipleQueryResultOfCountryDocumentField {
        data = typeof data === 'object' ? data : {};
        let result = new MultipleQueryResultOfCountryDocumentField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if(Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMultipleQueryResultOfCountryDocumentField {
    count?: number | undefined;
    data?: CountryDocumentField[] | undefined;
}

export class ChangeEmailViewModel implements IChangeEmailViewModel {
    email?: string | undefined;

    constructor(data?: IChangeEmailViewModel) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if(data) {
            this.email = data["email"];
        }
    }

    static fromJS(data: any): ChangeEmailViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeEmailViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }
}

export interface IChangeEmailViewModel {
    email?: string | undefined;
}

export class ConfirmChangeEmailViewModel implements IConfirmChangeEmailViewModel {
    confirmationCode?: string | undefined;

    constructor(data?: IConfirmChangeEmailViewModel) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if(data) {
            this.confirmationCode = data["confirmationCode"];
        }
    }

    static fromJS(data: any): ConfirmChangeEmailViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmChangeEmailViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["confirmationCode"] = this.confirmationCode;
        return data;
    }
}

export interface IConfirmChangeEmailViewModel {
    confirmationCode?: string | undefined;
}

export class SendConfirmationCodeViewModel implements ISendConfirmationCodeViewModel {
    email?: string | undefined;

    constructor(data?: ISendConfirmationCodeViewModel) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if(data) {
            this.email = data["email"];
        }
    }

    static fromJS(data: any): SendConfirmationCodeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SendConfirmationCodeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }
}

export interface ISendConfirmationCodeViewModel {
    email?: string | undefined;
}

export class ConfirmEmailViewModel implements IConfirmEmailViewModel {
    confirmationCode?: string | undefined;
    email?: string | undefined;

    constructor(data?: IConfirmEmailViewModel) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if(data) {
            this.confirmationCode = data["confirmationCode"];
            this.email = data["email"];
        }
    }

    static fromJS(data: any): ConfirmEmailViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmEmailViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["confirmationCode"] = this.confirmationCode;
        data["email"] = this.email;
        return data;
    }
}

export interface IConfirmEmailViewModel {
    confirmationCode?: string | undefined;
    email?: string | undefined;
}

export class OraclesResult implements IOraclesResult {
    oracles?: OracleModel[] | undefined;
    totalCount?: number | undefined;

    constructor(data?: IOraclesResult) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if(data) {
            if(Array.isArray(data["oracles"])) {
                this.oracles = [] as any;
                for (let item of data["oracles"])
                    this.oracles!.push(OracleModel.fromJS(item));
            }
            this.totalCount = data["totalCount"];
        }
    }

    static fromJS(data: any): OraclesResult {
        data = typeof data === 'object' ? data : {};
        let result = new OraclesResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if(Array.isArray(this.oracles)) {
            data["oracles"] = [];
            for (let item of this.oracles)
                data["oracles"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IOraclesResult {
    oracles?: OracleModel[] | undefined;
    totalCount?: number | undefined;
}

export class OracleModel implements IOracleModel {
    fullName?: string | undefined;
    description?: string | undefined;
    oracleProfileId?: number | undefined;
    isAdded?: boolean | undefined;
    isOracle?: boolean | undefined;
    avatarUrl?: string | undefined;
    profileType?: OracleModelProfileType | undefined;

    constructor(data?: IOracleModel) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if(data) {
            this.fullName = data["fullName"];
            this.description = data["description"];
            this.oracleProfileId = data["oracleProfileId"];
            this.isAdded = data["isAdded"];
            this.isOracle = data["isOracle"];
            this.avatarUrl = data["avatarUrl"];
            this.profileType = data["profileType"];
        }
    }

    static fromJS(data: any): OracleModel {
        data = typeof data === 'object' ? data : {};
        let result = new OracleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["description"] = this.description;
        data["oracleProfileId"] = this.oracleProfileId;
        data["isAdded"] = this.isAdded;
        data["isOracle"] = this.isOracle;
        data["avatarUrl"] = this.avatarUrl;
        data["profileType"] = this.profileType;
        return data;
    }
}

export interface IOracleModel {
    fullName?: string | undefined;
    description?: string | undefined;
    oracleProfileId?: number | undefined;
    isAdded?: boolean | undefined;
    isOracle?: boolean | undefined;
    avatarUrl?: string | undefined;
    profileType?: OracleModelProfileType | undefined;
}

export class OracleRequest implements IOracleRequest {
    profileId?: number | undefined;
    oracleProfileId?: number | undefined;

    constructor(data?: IOracleRequest) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if(data) {
            this.profileId = data["profileId"];
            this.oracleProfileId = data["oracleProfileId"];
        }
    }

    static fromJS(data: any): OracleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OracleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profileId"] = this.profileId;
        data["oracleProfileId"] = this.oracleProfileId;
        return data;
    }
}

export interface IOracleRequest {
    profileId?: number | undefined;
    oracleProfileId?: number | undefined;
}

export class ToggleOracleRequest implements IToggleOracleRequest {
    profileId?: number | undefined;
    value?: boolean | undefined;

    constructor(data?: IToggleOracleRequest) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if(data) {
            this.profileId = data["profileId"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): ToggleOracleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ToggleOracleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profileId"] = this.profileId;
        data["value"] = this.value;
        return data;
    }
}

export interface IToggleOracleRequest {
    profileId?: number | undefined;
    value?: boolean | undefined;
}

export class AgentResult implements IAgentResult {
    requestType?: AgentResultRequestType | undefined;
    id?: number | undefined;
    avatarUrl?: string | undefined;
    name?: string | undefined;
    fullName?: string | undefined;
    phoneNumber?: string | undefined;
    isDisplayPhoneNumber?: boolean | undefined;
    email?: string | undefined;
    isDisplayEmail?: boolean | undefined;
    isOracle?: boolean | undefined;
    description?: string | undefined;
    userId?: string | undefined;
    fingerprint?: string | undefined;

    constructor(data?: IAgentResult) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if(data) {
            this.requestType = data["requestType"];
            this.id = data["id"];
            this.avatarUrl = data["avatarUrl"];
            this.name = data["name"];
            this.fullName = data["fullName"];
            this.phoneNumber = data["phoneNumber"];
            this.isDisplayPhoneNumber = data["isDisplayPhoneNumber"];
            this.email = data["email"];
            this.isDisplayEmail = data["isDisplayEmail"];
            this.isOracle = data["isOracle"];
            this.description = data["description"];
            this.userId = data["userId"];
            this.fingerprint = data["fingerprint"];
        }
    }

    static fromJS(data: any): AgentResult {
        data = typeof data === 'object' ? data : {};
        let result = new AgentResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestType"] = this.requestType;
        data["id"] = this.id;
        data["avatarUrl"] = this.avatarUrl;
        data["name"] = this.name;
        data["fullName"] = this.fullName;
        data["phoneNumber"] = this.phoneNumber;
        data["isDisplayPhoneNumber"] = this.isDisplayPhoneNumber;
        data["email"] = this.email;
        data["isDisplayEmail"] = this.isDisplayEmail;
        data["isOracle"] = this.isOracle;
        data["description"] = this.description;
        data["userId"] = this.userId;
        data["fingerprint"] = this.fingerprint;
        return data;
    }
}

export interface IAgentResult {
    requestType?: AgentResultRequestType | undefined;
    id?: number | undefined;
    avatarUrl?: string | undefined;
    name?: string | undefined;
    fullName?: string | undefined;
    phoneNumber?: string | undefined;
    isDisplayPhoneNumber?: boolean | undefined;
    email?: string | undefined;
    isDisplayEmail?: boolean | undefined;
    isOracle?: boolean | undefined;
    description?: string | undefined;
    userId?: string | undefined;
    fingerprint?: string | undefined;
}

export class OrganizationResult implements IOrganizationResult {
    id?: number | undefined;
    avatarUrl?: string | undefined;
    name?: string | undefined;
    fullName?: string | undefined;
    phoneNumber?: string | undefined;
    isDisplayPhoneNumber?: boolean | undefined;
    email?: string | undefined;
    isDisplayEmail?: boolean | undefined;
    isOracle?: boolean | undefined;
    description?: string | undefined;
    userId?: string | undefined;
    fingerprint?: string | undefined;

    constructor(data?: IOrganizationResult) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if(data) {
            this.id = data["id"];
            this.avatarUrl = data["avatarUrl"];
            this.name = data["name"];
            this.fullName = data["fullName"];
            this.phoneNumber = data["phoneNumber"];
            this.isDisplayPhoneNumber = data["isDisplayPhoneNumber"];
            this.email = data["email"];
            this.isDisplayEmail = data["isDisplayEmail"];
            this.isOracle = data["isOracle"];
            this.description = data["description"];
            this.userId = data["userId"];
            this.fingerprint = data["fingerprint"];
        }
    }

    static fromJS(data: any): OrganizationResult {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["avatarUrl"] = this.avatarUrl;
        data["name"] = this.name;
        data["fullName"] = this.fullName;
        data["phoneNumber"] = this.phoneNumber;
        data["isDisplayPhoneNumber"] = this.isDisplayPhoneNumber;
        data["email"] = this.email;
        data["isDisplayEmail"] = this.isDisplayEmail;
        data["isOracle"] = this.isOracle;
        data["description"] = this.description;
        data["userId"] = this.userId;
        data["fingerprint"] = this.fingerprint;
        return data;
    }
}

export interface IOrganizationResult {
    id?: number | undefined;
    avatarUrl?: string | undefined;
    name?: string | undefined;
    fullName?: string | undefined;
    phoneNumber?: string | undefined;
    isDisplayPhoneNumber?: boolean | undefined;
    email?: string | undefined;
    isDisplayEmail?: boolean | undefined;
    isOracle?: boolean | undefined;
    description?: string | undefined;
    userId?: string | undefined;
    fingerprint?: string | undefined;
}

export class OrganizationAgentViewModel implements IOrganizationAgentViewModel {
    organizationProfileId?: number | undefined;
    agentProfileId?: number | undefined;

    constructor(data?: IOrganizationAgentViewModel) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if(data) {
            this.organizationProfileId = data["organizationProfileId"];
            this.agentProfileId = data["agentProfileId"];
        }
    }

    static fromJS(data: any): OrganizationAgentViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationAgentViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationProfileId"] = this.organizationProfileId;
        data["agentProfileId"] = this.agentProfileId;
        return data;
    }
}

export interface IOrganizationAgentViewModel {
    organizationProfileId?: number | undefined;
    agentProfileId?: number | undefined;
}

export class SetOrganizationAgentRequestTypeViewModel implements ISetOrganizationAgentRequestTypeViewModel {
    requestType?: SetOrganizationAgentRequestTypeViewModelRequestType | undefined;
    organizationProfileId?: number | undefined;
    agentProfileId?: number | undefined;

    constructor(data?: ISetOrganizationAgentRequestTypeViewModel) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if(data) {
            this.requestType = data["requestType"];
            this.organizationProfileId = data["organizationProfileId"];
            this.agentProfileId = data["agentProfileId"];
        }
    }

    static fromJS(data: any): SetOrganizationAgentRequestTypeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SetOrganizationAgentRequestTypeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestType"] = this.requestType;
        data["organizationProfileId"] = this.organizationProfileId;
        data["agentProfileId"] = this.agentProfileId;
        return data;
    }
}

export interface ISetOrganizationAgentRequestTypeViewModel {
    requestType?: SetOrganizationAgentRequestTypeViewModelRequestType | undefined;
    organizationProfileId?: number | undefined;
    agentProfileId?: number | undefined;
}

export class ChangePasswordRequest implements IChangePasswordRequest {
    currentPassword?: string | undefined;
    newPassword?: string | undefined;
    confirmNewPassword?: string | undefined;

    constructor(data?: IChangePasswordRequest) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if(data) {
            this.currentPassword = data["currentPassword"];
            this.newPassword = data["newPassword"];
            this.confirmNewPassword = data["confirmNewPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        data["confirmNewPassword"] = this.confirmNewPassword;
        return data;
    }
}

export interface IChangePasswordRequest {
    currentPassword?: string | undefined;
    newPassword?: string | undefined;
    confirmNewPassword?: string | undefined;
}

export class SetPasswordRequest implements ISetPasswordRequest {
    newPassword?: string | undefined;
    confirmNewPassword?: string | undefined;

    constructor(data?: ISetPasswordRequest) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if(data) {
            this.newPassword = data["newPassword"];
            this.confirmNewPassword = data["confirmNewPassword"];
        }
    }

    static fromJS(data: any): SetPasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetPasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newPassword"] = this.newPassword;
        data["confirmNewPassword"] = this.confirmNewPassword;
        return data;
    }
}

export interface ISetPasswordRequest {
    newPassword?: string | undefined;
    confirmNewPassword?: string | undefined;
}

export class CheckPasswordResult implements ICheckPasswordResult {
    isExist?: boolean | undefined;

    constructor(data?: ICheckPasswordResult) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if(data) {
            this.isExist = data["isExist"];
        }
    }

    static fromJS(data: any): CheckPasswordResult {
        data = typeof data === 'object' ? data : {};
        let result = new CheckPasswordResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isExist"] = this.isExist;
        return data;
    }
}

export interface ICheckPasswordResult {
    isExist?: boolean | undefined;
}

export class EmailWithConfirmationActionRequest implements IEmailWithConfirmationActionRequest {
    email?: string | undefined;
    confirmationAction?: string | undefined;

    constructor(data?: IEmailWithConfirmationActionRequest) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if(data) {
            this.email = data["email"];
            this.confirmationAction = data["confirmationAction"];
        }
    }

    static fromJS(data: any): EmailWithConfirmationActionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EmailWithConfirmationActionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["confirmationAction"] = this.confirmationAction;
        return data;
    }
}

export interface IEmailWithConfirmationActionRequest {
    email?: string | undefined;
    confirmationAction?: string | undefined;
}

export class ConfirmPasswordRecoveryRequest implements IConfirmPasswordRecoveryRequest {
    email?: string | undefined;
    token?: string | undefined;
    newPassword?: string | undefined;
    confirmNewPassword?: string | undefined;

    constructor(data?: IConfirmPasswordRecoveryRequest) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if(data) {
            this.email = data["email"];
            this.token = data["token"];
            this.newPassword = data["newPassword"];
            this.confirmNewPassword = data["confirmNewPassword"];
        }
    }

    static fromJS(data: any): ConfirmPasswordRecoveryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmPasswordRecoveryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["token"] = this.token;
        data["newPassword"] = this.newPassword;
        data["confirmNewPassword"] = this.confirmNewPassword;
        return data;
    }
}

export interface IConfirmPasswordRecoveryRequest {
    email?: string | undefined;
    token?: string | undefined;
    newPassword?: string | undefined;
    confirmNewPassword?: string | undefined;
}

export class MultipleQueryResultOfProfile implements IMultipleQueryResultOfProfile {
    count?: number | undefined;
    data?: Profile[] | undefined;

    constructor(data?: IMultipleQueryResultOfProfile) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if(data) {
            this.count = data["count"];
            if(Array.isArray(data["data"])) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(Profile.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MultipleQueryResultOfProfile {
        data = typeof data === 'object' ? data : {};
        let result = new MultipleQueryResultOfProfile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if(Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMultipleQueryResultOfProfile {
    count?: number | undefined;
    data?: Profile[] | undefined;
}

export class PersonalProfileResult implements IPersonalProfileResult {
    countryId?: number | undefined;
    countryName?: string | undefined;
    country2Code?: string | undefined;
    contractorCount?: number | undefined;
    oracleCount?: number | undefined;
    birthDate?: Date | undefined;
    city?: string | undefined;
    address?: string | undefined;
    postalCode?: number | undefined;
    province?: string | undefined;
    telegram?: string | undefined;
    skype?: string | undefined;
    isDisplayCountryId?: boolean | undefined;
    isDisplayBirthDate?: boolean | undefined;
    isDisplayTelegram?: boolean | undefined;
    isDisplaySkype?: boolean | undefined;
    isDisplayCity?: boolean | undefined;
    isDisplayAddress?: boolean | undefined;
    documents?: ProfileDocumentResult[] | undefined;
    id?: number | undefined;
    avatarUrl?: string | undefined;
    name?: string | undefined;
    fullName?: string | undefined;
    phoneNumber?: string | undefined;
    isDisplayPhoneNumber?: boolean | undefined;
    email?: string | undefined;
    isDisplayEmail?: boolean | undefined;
    isOracle?: boolean | undefined;
    description?: string | undefined;
    userId?: string | undefined;
    fingerprint?: string | undefined;

    constructor(data?: IPersonalProfileResult) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if(data) {
            this.countryId = data["countryId"];
            this.countryName = data["countryName"];
            this.country2Code = data["country2Code"];
            this.contractorCount = data["contractorCount"];
            this.oracleCount = data["oracleCount"];
            this.birthDate = data["birthDate"] ? new Date(data["birthDate"].toString()) : <any>undefined;
            this.city = data["city"];
            this.address = data["address"];
            this.postalCode = data["postalCode"];
            this.province = data["province"];
            this.telegram = data["telegram"];
            this.skype = data["skype"];
            this.isDisplayCountryId = data["isDisplayCountryId"];
            this.isDisplayBirthDate = data["isDisplayBirthDate"];
            this.isDisplayTelegram = data["isDisplayTelegram"];
            this.isDisplaySkype = data["isDisplaySkype"];
            this.isDisplayCity = data["isDisplayCity"];
            this.isDisplayAddress = data["isDisplayAddress"];
            if(Array.isArray(data["documents"])) {
                this.documents = [] as any;
                for (let item of data["documents"])
                    this.documents!.push(ProfileDocumentResult.fromJS(item));
            }
            this.id = data["id"];
            this.avatarUrl = data["avatarUrl"];
            this.name = data["name"];
            this.fullName = data["fullName"];
            this.phoneNumber = data["phoneNumber"];
            this.isDisplayPhoneNumber = data["isDisplayPhoneNumber"];
            this.email = data["email"];
            this.isDisplayEmail = data["isDisplayEmail"];
            this.isOracle = data["isOracle"];
            this.description = data["description"];
            this.userId = data["userId"];
            this.fingerprint = data["fingerprint"];
        }
    }

    static fromJS(data: any): PersonalProfileResult {
        data = typeof data === 'object' ? data : {};
        let result = new PersonalProfileResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryId"] = this.countryId;
        data["countryName"] = this.countryName;
        data["country2Code"] = this.country2Code;
        data["contractorCount"] = this.contractorCount;
        data["oracleCount"] = this.oracleCount;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["city"] = this.city;
        data["address"] = this.address;
        data["postalCode"] = this.postalCode;
        data["province"] = this.province;
        data["telegram"] = this.telegram;
        data["skype"] = this.skype;
        data["isDisplayCountryId"] = this.isDisplayCountryId;
        data["isDisplayBirthDate"] = this.isDisplayBirthDate;
        data["isDisplayTelegram"] = this.isDisplayTelegram;
        data["isDisplaySkype"] = this.isDisplaySkype;
        data["isDisplayCity"] = this.isDisplayCity;
        data["isDisplayAddress"] = this.isDisplayAddress;
        if(Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["avatarUrl"] = this.avatarUrl;
        data["name"] = this.name;
        data["fullName"] = this.fullName;
        data["phoneNumber"] = this.phoneNumber;
        data["isDisplayPhoneNumber"] = this.isDisplayPhoneNumber;
        data["email"] = this.email;
        data["isDisplayEmail"] = this.isDisplayEmail;
        data["isOracle"] = this.isOracle;
        data["description"] = this.description;
        data["userId"] = this.userId;
        data["fingerprint"] = this.fingerprint;
        return data;
    }
}

export interface IPersonalProfileResult {
    countryId?: number | undefined;
    countryName?: string | undefined;
    country2Code?: string | undefined;
    contractorCount?: number | undefined;
    oracleCount?: number | undefined;
    birthDate?: Date | undefined;
    city?: string | undefined;
    address?: string | undefined;
    postalCode?: number | undefined;
    province?: string | undefined;
    telegram?: string | undefined;
    skype?: string | undefined;
    isDisplayCountryId?: boolean | undefined;
    isDisplayBirthDate?: boolean | undefined;
    isDisplayTelegram?: boolean | undefined;
    isDisplaySkype?: boolean | undefined;
    isDisplayCity?: boolean | undefined;
    isDisplayAddress?: boolean | undefined;
    documents?: ProfileDocumentResult[] | undefined;
    id?: number | undefined;
    avatarUrl?: string | undefined;
    name?: string | undefined;
    fullName?: string | undefined;
    phoneNumber?: string | undefined;
    isDisplayPhoneNumber?: boolean | undefined;
    email?: string | undefined;
    isDisplayEmail?: boolean | undefined;
    isOracle?: boolean | undefined;
    description?: string | undefined;
    userId?: string | undefined;
    fingerprint?: string | undefined;
}

export class ProfileDocumentResult implements IProfileDocumentResult {
    id?: number | undefined;
    profileId?: number | undefined;
    countryId?: number | undefined;
    documentType?: ProfileDocumentResultDocumentType | undefined;
    documentNumber?: string | undefined;
    documentSurname?: string | undefined;
    documentName?: string | undefined;
    documentBirthDate?: Date | undefined;
    documentIssuedDate?: Date | undefined;
    documentAuthority?: string | undefined;
    documentExpiryDate?: Date | undefined;
    documentBirthPlace?: string | undefined;
    documentNationality?: string | undefined;
    documentSex?: string | undefined;
    documentAddress?: string | undefined;
    documentPersonalNumber?: string | undefined;
    documentHeight?: string | undefined;
    documentCharType?: string | undefined;
    documentCountryCode?: string | undefined;
    documentResidence?: string | undefined;
    documentCardName?: string | undefined;
    documentReligion?: string | undefined;
    documentCardAdministrative?: string | undefined;
    documentCardPIN?: string | undefined;
    documentStartDate?: Date | undefined;
    driverLicenseCategory?: string | undefined;
    driverAlamat?: string | undefined;
    driverTempat?: string | undefined;
    driverPekerjaan?: string | undefined;
    driverSIM?: string | undefined;
    driverBerlaku?: string | undefined;
    driverProvinceCode?: string | undefined;
    driverPlaceRegistration?: string | undefined;
    driverDateRegistration?: Date | undefined;
    driverHeadquarter?: string | undefined;
    driverConditions?: string | undefined;
    driverClass?: string | undefined;
    isDisplayDocument?: boolean | undefined;

    constructor(data?: IProfileDocumentResult) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if(data) {
            this.id = data["id"];
            this.profileId = data["profileId"];
            this.countryId = data["countryId"];
            this.documentType = data["documentType"];
            this.documentNumber = data["documentNumber"];
            this.documentSurname = data["documentSurname"];
            this.documentName = data["documentName"];
            this.documentBirthDate = data["documentBirthDate"] ? new Date(data["documentBirthDate"].toString()) : <any>undefined;
            this.documentIssuedDate = data["documentIssuedDate"] ? new Date(data["documentIssuedDate"].toString()) : <any>undefined;
            this.documentAuthority = data["documentAuthority"];
            this.documentExpiryDate = data["documentExpiryDate"] ? new Date(data["documentExpiryDate"].toString()) : <any>undefined;
            this.documentBirthPlace = data["documentBirthPlace"];
            this.documentNationality = data["documentNationality"];
            this.documentSex = data["documentSex"];
            this.documentAddress = data["documentAddress"];
            this.documentPersonalNumber = data["documentPersonalNumber"];
            this.documentHeight = data["documentHeight"];
            this.documentCharType = data["documentCharType"];
            this.documentCountryCode = data["documentCountryCode"];
            this.documentResidence = data["documentResidence"];
            this.documentCardName = data["documentCardName"];
            this.documentReligion = data["documentReligion"];
            this.documentCardAdministrative = data["documentCardAdministrative"];
            this.documentCardPIN = data["documentCardPIN"];
            this.documentStartDate = data["documentStartDate"] ? new Date(data["documentStartDate"].toString()) : <any>undefined;
            this.driverLicenseCategory = data["driverLicenseCategory"];
            this.driverAlamat = data["driverAlamat"];
            this.driverTempat = data["driverTempat"];
            this.driverPekerjaan = data["driverPekerjaan"];
            this.driverSIM = data["driverSIM"];
            this.driverBerlaku = data["driverBerlaku"];
            this.driverProvinceCode = data["driverProvinceCode"];
            this.driverPlaceRegistration = data["driverPlaceRegistration"];
            this.driverDateRegistration = data["driverDateRegistration"] ? new Date(data["driverDateRegistration"].toString()) : <any>undefined;
            this.driverHeadquarter = data["driverHeadquarter"];
            this.driverConditions = data["driverConditions"];
            this.driverClass = data["driverClass"];
            this.isDisplayDocument = data["isDisplayDocument"];
        }
    }

    static fromJS(data: any): ProfileDocumentResult {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileDocumentResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["profileId"] = this.profileId;
        data["countryId"] = this.countryId;
        data["documentType"] = this.documentType;
        data["documentNumber"] = this.documentNumber;
        data["documentSurname"] = this.documentSurname;
        data["documentName"] = this.documentName;
        data["documentBirthDate"] = this.documentBirthDate ? this.documentBirthDate.toISOString() : <any>undefined;
        data["documentIssuedDate"] = this.documentIssuedDate ? this.documentIssuedDate.toISOString() : <any>undefined;
        data["documentAuthority"] = this.documentAuthority;
        data["documentExpiryDate"] = this.documentExpiryDate ? this.documentExpiryDate.toISOString() : <any>undefined;
        data["documentBirthPlace"] = this.documentBirthPlace;
        data["documentNationality"] = this.documentNationality;
        data["documentSex"] = this.documentSex;
        data["documentAddress"] = this.documentAddress;
        data["documentPersonalNumber"] = this.documentPersonalNumber;
        data["documentHeight"] = this.documentHeight;
        data["documentCharType"] = this.documentCharType;
        data["documentCountryCode"] = this.documentCountryCode;
        data["documentResidence"] = this.documentResidence;
        data["documentCardName"] = this.documentCardName;
        data["documentReligion"] = this.documentReligion;
        data["documentCardAdministrative"] = this.documentCardAdministrative;
        data["documentCardPIN"] = this.documentCardPIN;
        data["documentStartDate"] = this.documentStartDate ? this.documentStartDate.toISOString() : <any>undefined;
        data["driverLicenseCategory"] = this.driverLicenseCategory;
        data["driverAlamat"] = this.driverAlamat;
        data["driverTempat"] = this.driverTempat;
        data["driverPekerjaan"] = this.driverPekerjaan;
        data["driverSIM"] = this.driverSIM;
        data["driverBerlaku"] = this.driverBerlaku;
        data["driverProvinceCode"] = this.driverProvinceCode;
        data["driverPlaceRegistration"] = this.driverPlaceRegistration;
        data["driverDateRegistration"] = this.driverDateRegistration ? this.driverDateRegistration.toISOString() : <any>undefined;
        data["driverHeadquarter"] = this.driverHeadquarter;
        data["driverConditions"] = this.driverConditions;
        data["driverClass"] = this.driverClass;
        data["isDisplayDocument"] = this.isDisplayDocument;
        return data;
    }
}

export interface IProfileDocumentResult {
    id?: number | undefined;
    profileId?: number | undefined;
    countryId?: number | undefined;
    documentType?: ProfileDocumentResultDocumentType | undefined;
    documentNumber?: string | undefined;
    documentSurname?: string | undefined;
    documentName?: string | undefined;
    documentBirthDate?: Date | undefined;
    documentIssuedDate?: Date | undefined;
    documentAuthority?: string | undefined;
    documentExpiryDate?: Date | undefined;
    documentBirthPlace?: string | undefined;
    documentNationality?: string | undefined;
    documentSex?: string | undefined;
    documentAddress?: string | undefined;
    documentPersonalNumber?: string | undefined;
    documentHeight?: string | undefined;
    documentCharType?: string | undefined;
    documentCountryCode?: string | undefined;
    documentResidence?: string | undefined;
    documentCardName?: string | undefined;
    documentReligion?: string | undefined;
    documentCardAdministrative?: string | undefined;
    documentCardPIN?: string | undefined;
    documentStartDate?: Date | undefined;
    driverLicenseCategory?: string | undefined;
    driverAlamat?: string | undefined;
    driverTempat?: string | undefined;
    driverPekerjaan?: string | undefined;
    driverSIM?: string | undefined;
    driverBerlaku?: string | undefined;
    driverProvinceCode?: string | undefined;
    driverPlaceRegistration?: string | undefined;
    driverDateRegistration?: Date | undefined;
    driverHeadquarter?: string | undefined;
    driverConditions?: string | undefined;
    driverClass?: string | undefined;
    isDisplayDocument?: boolean | undefined;
}

export class OrganizationProfileResult implements IOrganizationProfileResult {
    typeOrganization?: string | undefined;
    tin?: string | undefined;
    registrationAddress?: string | undefined;
    phoneCompany?: string | undefined;
    psrn?: string | undefined;
    license?: string | undefined;
    contractorCount?: number | undefined;
    oracleCount?: number | undefined;
    isDisplayTypeOrganization?: boolean | undefined;
    isDisplayTin?: boolean | undefined;
    isDisplayPhoneCompany?: boolean | undefined;
    isDisplayRegistrationAddress?: boolean | undefined;
    isDisplayPsrn?: boolean | undefined;
    isDisplayLicense?: boolean | undefined;
    id?: number | undefined;
    avatarUrl?: string | undefined;
    name?: string | undefined;
    fullName?: string | undefined;
    phoneNumber?: string | undefined;
    isDisplayPhoneNumber?: boolean | undefined;
    email?: string | undefined;
    isDisplayEmail?: boolean | undefined;
    isOracle?: boolean | undefined;
    description?: string | undefined;
    userId?: string | undefined;
    fingerprint?: string | undefined;

    constructor(data?: IOrganizationProfileResult) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if(data) {
            this.typeOrganization = data["typeOrganization"];
            this.tin = data["tin"];
            this.registrationAddress = data["registrationAddress"];
            this.phoneCompany = data["phoneCompany"];
            this.psrn = data["psrn"];
            this.license = data["license"];
            this.contractorCount = data["contractorCount"];
            this.oracleCount = data["oracleCount"];
            this.isDisplayTypeOrganization = data["isDisplayTypeOrganization"];
            this.isDisplayTin = data["isDisplayTin"];
            this.isDisplayPhoneCompany = data["isDisplayPhoneCompany"];
            this.isDisplayRegistrationAddress = data["isDisplayRegistrationAddress"];
            this.isDisplayPsrn = data["isDisplayPsrn"];
            this.isDisplayLicense = data["isDisplayLicense"];
            this.id = data["id"];
            this.avatarUrl = data["avatarUrl"];
            this.name = data["name"];
            this.fullName = data["fullName"];
            this.phoneNumber = data["phoneNumber"];
            this.isDisplayPhoneNumber = data["isDisplayPhoneNumber"];
            this.email = data["email"];
            this.isDisplayEmail = data["isDisplayEmail"];
            this.isOracle = data["isOracle"];
            this.description = data["description"];
            this.userId = data["userId"];
            this.fingerprint = data["fingerprint"];
        }
    }

    static fromJS(data: any): OrganizationProfileResult {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationProfileResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeOrganization"] = this.typeOrganization;
        data["tin"] = this.tin;
        data["registrationAddress"] = this.registrationAddress;
        data["phoneCompany"] = this.phoneCompany;
        data["psrn"] = this.psrn;
        data["license"] = this.license;
        data["contractorCount"] = this.contractorCount;
        data["oracleCount"] = this.oracleCount;
        data["isDisplayTypeOrganization"] = this.isDisplayTypeOrganization;
        data["isDisplayTin"] = this.isDisplayTin;
        data["isDisplayPhoneCompany"] = this.isDisplayPhoneCompany;
        data["isDisplayRegistrationAddress"] = this.isDisplayRegistrationAddress;
        data["isDisplayPsrn"] = this.isDisplayPsrn;
        data["isDisplayLicense"] = this.isDisplayLicense;
        data["id"] = this.id;
        data["avatarUrl"] = this.avatarUrl;
        data["name"] = this.name;
        data["fullName"] = this.fullName;
        data["phoneNumber"] = this.phoneNumber;
        data["isDisplayPhoneNumber"] = this.isDisplayPhoneNumber;
        data["email"] = this.email;
        data["isDisplayEmail"] = this.isDisplayEmail;
        data["isOracle"] = this.isOracle;
        data["description"] = this.description;
        data["userId"] = this.userId;
        data["fingerprint"] = this.fingerprint;
        return data;
    }
}

export interface IOrganizationProfileResult {
    typeOrganization?: string | undefined;
    tin?: string | undefined;
    registrationAddress?: string | undefined;
    phoneCompany?: string | undefined;
    psrn?: string | undefined;
    license?: string | undefined;
    contractorCount?: number | undefined;
    oracleCount?: number | undefined;
    isDisplayTypeOrganization?: boolean | undefined;
    isDisplayTin?: boolean | undefined;
    isDisplayPhoneCompany?: boolean | undefined;
    isDisplayRegistrationAddress?: boolean | undefined;
    isDisplayPsrn?: boolean | undefined;
    isDisplayLicense?: boolean | undefined;
    id?: number | undefined;
    avatarUrl?: string | undefined;
    name?: string | undefined;
    fullName?: string | undefined;
    phoneNumber?: string | undefined;
    isDisplayPhoneNumber?: boolean | undefined;
    email?: string | undefined;
    isDisplayEmail?: boolean | undefined;
    isOracle?: boolean | undefined;
    description?: string | undefined;
    userId?: string | undefined;
    fingerprint?: string | undefined;
}

/** Query model 'Edit personal profile'. */
export class EditPersonalProfileViewModel implements IEditPersonalProfileViewModel {
    id?: number | undefined;
    countryId?: number | undefined;
    birthDate?: Date | undefined;
    city?: string | undefined;
    address?: string | undefined;
    postalCode?: number | undefined;
    province?: string | undefined;
    telegram?: string | undefined;
    skype?: string | undefined;
    isDisplayCountryId?: boolean | undefined;
    isDisplayBirthDate?: boolean | undefined;
    isDisplayTelegram?: boolean | undefined;
    isDisplaySkype?: boolean | undefined;
    isDisplayCity?: boolean | undefined;
    isDisplayAddress?: boolean | undefined;
    documents?: ProfileDocumentViewModel[] | undefined;
    name?: string | undefined;
    fullName?: string | undefined;
    phoneNumber?: string | undefined;
    description?: string | undefined;
    isDisplayPhoneNumber?: boolean | undefined;
    email?: string | undefined;
    isDisplayEmail?: boolean | undefined;
    isOracle?: boolean | undefined;

    constructor(data?: IEditPersonalProfileViewModel) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if(data) {
            this.id = data["id"];
            this.countryId = data["countryId"];
            this.birthDate = data["birthDate"] ? new Date(data["birthDate"].toString()) : <any>undefined;
            this.city = data["city"];
            this.address = data["address"];
            this.postalCode = data["postalCode"];
            this.province = data["province"];
            this.telegram = data["telegram"];
            this.skype = data["skype"];
            this.isDisplayCountryId = data["isDisplayCountryId"];
            this.isDisplayBirthDate = data["isDisplayBirthDate"];
            this.isDisplayTelegram = data["isDisplayTelegram"];
            this.isDisplaySkype = data["isDisplaySkype"];
            this.isDisplayCity = data["isDisplayCity"];
            this.isDisplayAddress = data["isDisplayAddress"];
            if(Array.isArray(data["documents"])) {
                this.documents = [] as any;
                for (let item of data["documents"])
                    this.documents!.push(ProfileDocumentViewModel.fromJS(item));
            }
            this.name = data["name"];
            this.fullName = data["fullName"];
            this.phoneNumber = data["phoneNumber"];
            this.description = data["description"];
            this.isDisplayPhoneNumber = data["isDisplayPhoneNumber"];
            this.email = data["email"];
            this.isDisplayEmail = data["isDisplayEmail"];
            this.isOracle = data["isOracle"];
        }
    }

    static fromJS(data: any): EditPersonalProfileViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EditPersonalProfileViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["countryId"] = this.countryId;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["city"] = this.city;
        data["address"] = this.address;
        data["postalCode"] = this.postalCode;
        data["province"] = this.province;
        data["telegram"] = this.telegram;
        data["skype"] = this.skype;
        data["isDisplayCountryId"] = this.isDisplayCountryId;
        data["isDisplayBirthDate"] = this.isDisplayBirthDate;
        data["isDisplayTelegram"] = this.isDisplayTelegram;
        data["isDisplaySkype"] = this.isDisplaySkype;
        data["isDisplayCity"] = this.isDisplayCity;
        data["isDisplayAddress"] = this.isDisplayAddress;
        if(Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["name"] = this.name;
        data["fullName"] = this.fullName;
        data["phoneNumber"] = this.phoneNumber;
        data["description"] = this.description;
        data["isDisplayPhoneNumber"] = this.isDisplayPhoneNumber;
        data["email"] = this.email;
        data["isDisplayEmail"] = this.isDisplayEmail;
        data["isOracle"] = this.isOracle;
        return data;
    }
}

/** Query model 'Edit personal profile'. */
export interface IEditPersonalProfileViewModel {
    id?: number | undefined;
    countryId?: number | undefined;
    birthDate?: Date | undefined;
    city?: string | undefined;
    address?: string | undefined;
    postalCode?: number | undefined;
    province?: string | undefined;
    telegram?: string | undefined;
    skype?: string | undefined;
    isDisplayCountryId?: boolean | undefined;
    isDisplayBirthDate?: boolean | undefined;
    isDisplayTelegram?: boolean | undefined;
    isDisplaySkype?: boolean | undefined;
    isDisplayCity?: boolean | undefined;
    isDisplayAddress?: boolean | undefined;
    documents?: ProfileDocumentViewModel[] | undefined;
    name?: string | undefined;
    fullName?: string | undefined;
    phoneNumber?: string | undefined;
    description?: string | undefined;
    isDisplayPhoneNumber?: boolean | undefined;
    email?: string | undefined;
    isDisplayEmail?: boolean | undefined;
    isOracle?: boolean | undefined;
}

export class ProfileDocumentViewModel implements IProfileDocumentViewModel {
    id?: number | undefined;
    profileId?: number | undefined;
    countryId?: number | undefined;
    documentType?: ProfileDocumentViewModelDocumentType | undefined;
    documentNumber?: string | undefined;
    documentSurname?: string | undefined;
    documentName?: string | undefined;
    documentBirthDate?: Date | undefined;
    documentIssuedDate?: Date | undefined;
    documentAuthority?: string | undefined;
    documentExpiryDate?: Date | undefined;
    documentBirthPlace?: string | undefined;
    documentNationality?: string | undefined;
    documentSex?: string | undefined;
    documentAddress?: string | undefined;
    documentPersonalNumber?: string | undefined;
    documentHeight?: string | undefined;
    documentCharType?: string | undefined;
    documentCountryCode?: string | undefined;
    documentResidence?: string | undefined;
    documentCardName?: string | undefined;
    documentReligion?: string | undefined;
    documentCardAdministrative?: string | undefined;
    documentCardPIN?: string | undefined;
    documentStartDate?: Date | undefined;
    driverLicenseCategory?: string | undefined;
    driverAlamat?: string | undefined;
    driverTempat?: string | undefined;
    driverPekerjaan?: string | undefined;
    driverSIM?: string | undefined;
    driverBerlaku?: string | undefined;
    driverProvinceCode?: string | undefined;
    driverPlaceRegistration?: string | undefined;
    driverDateRegistration?: Date | undefined;
    driverHeadquarter?: string | undefined;
    driverConditions?: string | undefined;
    driverClass?: string | undefined;
    isDisplayDocument?: boolean | undefined;

    constructor(data?: IProfileDocumentViewModel) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if(data) {
            this.id = data["id"];
            this.profileId = data["profileId"];
            this.countryId = data["countryId"];
            this.documentType = data["documentType"];
            this.documentNumber = data["documentNumber"];
            this.documentSurname = data["documentSurname"];
            this.documentName = data["documentName"];
            this.documentBirthDate = data["documentBirthDate"] ? new Date(data["documentBirthDate"].toString()) : <any>undefined;
            this.documentIssuedDate = data["documentIssuedDate"] ? new Date(data["documentIssuedDate"].toString()) : <any>undefined;
            this.documentAuthority = data["documentAuthority"];
            this.documentExpiryDate = data["documentExpiryDate"] ? new Date(data["documentExpiryDate"].toString()) : <any>undefined;
            this.documentBirthPlace = data["documentBirthPlace"];
            this.documentNationality = data["documentNationality"];
            this.documentSex = data["documentSex"];
            this.documentAddress = data["documentAddress"];
            this.documentPersonalNumber = data["documentPersonalNumber"];
            this.documentHeight = data["documentHeight"];
            this.documentCharType = data["documentCharType"];
            this.documentCountryCode = data["documentCountryCode"];
            this.documentResidence = data["documentResidence"];
            this.documentCardName = data["documentCardName"];
            this.documentReligion = data["documentReligion"];
            this.documentCardAdministrative = data["documentCardAdministrative"];
            this.documentCardPIN = data["documentCardPIN"];
            this.documentStartDate = data["documentStartDate"] ? new Date(data["documentStartDate"].toString()) : <any>undefined;
            this.driverLicenseCategory = data["driverLicenseCategory"];
            this.driverAlamat = data["driverAlamat"];
            this.driverTempat = data["driverTempat"];
            this.driverPekerjaan = data["driverPekerjaan"];
            this.driverSIM = data["driverSIM"];
            this.driverBerlaku = data["driverBerlaku"];
            this.driverProvinceCode = data["driverProvinceCode"];
            this.driverPlaceRegistration = data["driverPlaceRegistration"];
            this.driverDateRegistration = data["driverDateRegistration"] ? new Date(data["driverDateRegistration"].toString()) : <any>undefined;
            this.driverHeadquarter = data["driverHeadquarter"];
            this.driverConditions = data["driverConditions"];
            this.driverClass = data["driverClass"];
            this.isDisplayDocument = data["isDisplayDocument"];
        }
    }

    static fromJS(data: any): ProfileDocumentViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileDocumentViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["profileId"] = this.profileId;
        data["countryId"] = this.countryId;
        data["documentType"] = this.documentType;
        data["documentNumber"] = this.documentNumber;
        data["documentSurname"] = this.documentSurname;
        data["documentName"] = this.documentName;
        data["documentBirthDate"] = this.documentBirthDate ? this.documentBirthDate.toISOString() : <any>undefined;
        data["documentIssuedDate"] = this.documentIssuedDate ? this.documentIssuedDate.toISOString() : <any>undefined;
        data["documentAuthority"] = this.documentAuthority;
        data["documentExpiryDate"] = this.documentExpiryDate ? this.documentExpiryDate.toISOString() : <any>undefined;
        data["documentBirthPlace"] = this.documentBirthPlace;
        data["documentNationality"] = this.documentNationality;
        data["documentSex"] = this.documentSex;
        data["documentAddress"] = this.documentAddress;
        data["documentPersonalNumber"] = this.documentPersonalNumber;
        data["documentHeight"] = this.documentHeight;
        data["documentCharType"] = this.documentCharType;
        data["documentCountryCode"] = this.documentCountryCode;
        data["documentResidence"] = this.documentResidence;
        data["documentCardName"] = this.documentCardName;
        data["documentReligion"] = this.documentReligion;
        data["documentCardAdministrative"] = this.documentCardAdministrative;
        data["documentCardPIN"] = this.documentCardPIN;
        data["documentStartDate"] = this.documentStartDate ? this.documentStartDate.toISOString() : <any>undefined;
        data["driverLicenseCategory"] = this.driverLicenseCategory;
        data["driverAlamat"] = this.driverAlamat;
        data["driverTempat"] = this.driverTempat;
        data["driverPekerjaan"] = this.driverPekerjaan;
        data["driverSIM"] = this.driverSIM;
        data["driverBerlaku"] = this.driverBerlaku;
        data["driverProvinceCode"] = this.driverProvinceCode;
        data["driverPlaceRegistration"] = this.driverPlaceRegistration;
        data["driverDateRegistration"] = this.driverDateRegistration ? this.driverDateRegistration.toISOString() : <any>undefined;
        data["driverHeadquarter"] = this.driverHeadquarter;
        data["driverConditions"] = this.driverConditions;
        data["driverClass"] = this.driverClass;
        data["isDisplayDocument"] = this.isDisplayDocument;
        return data;
    }
}

export interface IProfileDocumentViewModel {
    id?: number | undefined;
    profileId?: number | undefined;
    countryId?: number | undefined;
    documentType?: ProfileDocumentViewModelDocumentType | undefined;
    documentNumber?: string | undefined;
    documentSurname?: string | undefined;
    documentName?: string | undefined;
    documentBirthDate?: Date | undefined;
    documentIssuedDate?: Date | undefined;
    documentAuthority?: string | undefined;
    documentExpiryDate?: Date | undefined;
    documentBirthPlace?: string | undefined;
    documentNationality?: string | undefined;
    documentSex?: string | undefined;
    documentAddress?: string | undefined;
    documentPersonalNumber?: string | undefined;
    documentHeight?: string | undefined;
    documentCharType?: string | undefined;
    documentCountryCode?: string | undefined;
    documentResidence?: string | undefined;
    documentCardName?: string | undefined;
    documentReligion?: string | undefined;
    documentCardAdministrative?: string | undefined;
    documentCardPIN?: string | undefined;
    documentStartDate?: Date | undefined;
    driverLicenseCategory?: string | undefined;
    driverAlamat?: string | undefined;
    driverTempat?: string | undefined;
    driverPekerjaan?: string | undefined;
    driverSIM?: string | undefined;
    driverBerlaku?: string | undefined;
    driverProvinceCode?: string | undefined;
    driverPlaceRegistration?: string | undefined;
    driverDateRegistration?: Date | undefined;
    driverHeadquarter?: string | undefined;
    driverConditions?: string | undefined;
    driverClass?: string | undefined;
    isDisplayDocument?: boolean | undefined;
}

/** Query model 'Personal profile'. */
export class PersonalProfileViewModel implements IPersonalProfileViewModel {
    countryId?: number | undefined;
    birthDate?: Date | undefined;
    city?: string | undefined;
    address?: string | undefined;
    postalCode?: number | undefined;
    province?: string | undefined;
    telegram?: string | undefined;
    skype?: string | undefined;
    isDisplayCountryId?: boolean | undefined;
    isDisplayBirthDate?: boolean | undefined;
    isDisplayTelegram?: boolean | undefined;
    isDisplaySkype?: boolean | undefined;
    isDisplayCity?: boolean | undefined;
    isDisplayAddress?: boolean | undefined;
    documents?: ProfileDocumentViewModel[] | undefined;
    name?: string | undefined;
    fullName?: string | undefined;
    phoneNumber?: string | undefined;
    description?: string | undefined;
    isDisplayPhoneNumber?: boolean | undefined;
    email?: string | undefined;
    isDisplayEmail?: boolean | undefined;
    isOracle?: boolean | undefined;

    constructor(data?: IPersonalProfileViewModel) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if(data) {
            this.countryId = data["countryId"];
            this.birthDate = data["birthDate"] ? new Date(data["birthDate"].toString()) : <any>undefined;
            this.city = data["city"];
            this.address = data["address"];
            this.postalCode = data["postalCode"];
            this.province = data["province"];
            this.telegram = data["telegram"];
            this.skype = data["skype"];
            this.isDisplayCountryId = data["isDisplayCountryId"];
            this.isDisplayBirthDate = data["isDisplayBirthDate"];
            this.isDisplayTelegram = data["isDisplayTelegram"];
            this.isDisplaySkype = data["isDisplaySkype"];
            this.isDisplayCity = data["isDisplayCity"];
            this.isDisplayAddress = data["isDisplayAddress"];
            if(Array.isArray(data["documents"])) {
                this.documents = [] as any;
                for (let item of data["documents"])
                    this.documents!.push(ProfileDocumentViewModel.fromJS(item));
            }
            this.name = data["name"];
            this.fullName = data["fullName"];
            this.phoneNumber = data["phoneNumber"];
            this.description = data["description"];
            this.isDisplayPhoneNumber = data["isDisplayPhoneNumber"];
            this.email = data["email"];
            this.isDisplayEmail = data["isDisplayEmail"];
            this.isOracle = data["isOracle"];
        }
    }

    static fromJS(data: any): PersonalProfileViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PersonalProfileViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryId"] = this.countryId;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["city"] = this.city;
        data["address"] = this.address;
        data["postalCode"] = this.postalCode;
        data["province"] = this.province;
        data["telegram"] = this.telegram;
        data["skype"] = this.skype;
        data["isDisplayCountryId"] = this.isDisplayCountryId;
        data["isDisplayBirthDate"] = this.isDisplayBirthDate;
        data["isDisplayTelegram"] = this.isDisplayTelegram;
        data["isDisplaySkype"] = this.isDisplaySkype;
        data["isDisplayCity"] = this.isDisplayCity;
        data["isDisplayAddress"] = this.isDisplayAddress;
        if(Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["name"] = this.name;
        data["fullName"] = this.fullName;
        data["phoneNumber"] = this.phoneNumber;
        data["description"] = this.description;
        data["isDisplayPhoneNumber"] = this.isDisplayPhoneNumber;
        data["email"] = this.email;
        data["isDisplayEmail"] = this.isDisplayEmail;
        data["isOracle"] = this.isOracle;
        return data;
    }
}

/** Query model 'Personal profile'. */
export interface IPersonalProfileViewModel {
    countryId?: number | undefined;
    birthDate?: Date | undefined;
    city?: string | undefined;
    address?: string | undefined;
    postalCode?: number | undefined;
    province?: string | undefined;
    telegram?: string | undefined;
    skype?: string | undefined;
    isDisplayCountryId?: boolean | undefined;
    isDisplayBirthDate?: boolean | undefined;
    isDisplayTelegram?: boolean | undefined;
    isDisplaySkype?: boolean | undefined;
    isDisplayCity?: boolean | undefined;
    isDisplayAddress?: boolean | undefined;
    documents?: ProfileDocumentViewModel[] | undefined;
    name?: string | undefined;
    fullName?: string | undefined;
    phoneNumber?: string | undefined;
    description?: string | undefined;
    isDisplayPhoneNumber?: boolean | undefined;
    email?: string | undefined;
    isDisplayEmail?: boolean | undefined;
    isOracle?: boolean | undefined;
}

/** Query model 'Edit organization profile'. */
export class EditOrganizationProfileViewModel implements IEditOrganizationProfileViewModel {
    id?: number | undefined;
    typeOrganization?: string | undefined;
    tin?: string | undefined;
    phoneCompany?: string | undefined;
    registrationAddress?: string | undefined;
    psrn?: string | undefined;
    license?: string | undefined;
    isDisplayTypeOrganization?: boolean | undefined;
    isDisplayTin?: boolean | undefined;
    isDisplayPhoneCompany?: boolean | undefined;
    isDisplayRegistrationAddress?: boolean | undefined;
    isDisplayPsrn?: boolean | undefined;
    isDisplayLicense?: boolean | undefined;
    name?: string | undefined;
    fullName?: string | undefined;
    phoneNumber?: string | undefined;
    description?: string | undefined;
    isDisplayPhoneNumber?: boolean | undefined;
    email?: string | undefined;
    isDisplayEmail?: boolean | undefined;
    isOracle?: boolean | undefined;

    constructor(data?: IEditOrganizationProfileViewModel) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if(data) {
            this.id = data["id"];
            this.typeOrganization = data["typeOrganization"];
            this.tin = data["tin"];
            this.phoneCompany = data["phoneCompany"];
            this.registrationAddress = data["registrationAddress"];
            this.psrn = data["psrn"];
            this.license = data["license"];
            this.isDisplayTypeOrganization = data["isDisplayTypeOrganization"];
            this.isDisplayTin = data["isDisplayTin"];
            this.isDisplayPhoneCompany = data["isDisplayPhoneCompany"];
            this.isDisplayRegistrationAddress = data["isDisplayRegistrationAddress"];
            this.isDisplayPsrn = data["isDisplayPsrn"];
            this.isDisplayLicense = data["isDisplayLicense"];
            this.name = data["name"];
            this.fullName = data["fullName"];
            this.phoneNumber = data["phoneNumber"];
            this.description = data["description"];
            this.isDisplayPhoneNumber = data["isDisplayPhoneNumber"];
            this.email = data["email"];
            this.isDisplayEmail = data["isDisplayEmail"];
            this.isOracle = data["isOracle"];
        }
    }

    static fromJS(data: any): EditOrganizationProfileViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EditOrganizationProfileViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["typeOrganization"] = this.typeOrganization;
        data["tin"] = this.tin;
        data["phoneCompany"] = this.phoneCompany;
        data["registrationAddress"] = this.registrationAddress;
        data["psrn"] = this.psrn;
        data["license"] = this.license;
        data["isDisplayTypeOrganization"] = this.isDisplayTypeOrganization;
        data["isDisplayTin"] = this.isDisplayTin;
        data["isDisplayPhoneCompany"] = this.isDisplayPhoneCompany;
        data["isDisplayRegistrationAddress"] = this.isDisplayRegistrationAddress;
        data["isDisplayPsrn"] = this.isDisplayPsrn;
        data["isDisplayLicense"] = this.isDisplayLicense;
        data["name"] = this.name;
        data["fullName"] = this.fullName;
        data["phoneNumber"] = this.phoneNumber;
        data["description"] = this.description;
        data["isDisplayPhoneNumber"] = this.isDisplayPhoneNumber;
        data["email"] = this.email;
        data["isDisplayEmail"] = this.isDisplayEmail;
        data["isOracle"] = this.isOracle;
        return data;
    }
}

/** Query model 'Edit organization profile'. */
export interface IEditOrganizationProfileViewModel {
    id?: number | undefined;
    typeOrganization?: string | undefined;
    tin?: string | undefined;
    phoneCompany?: string | undefined;
    registrationAddress?: string | undefined;
    psrn?: string | undefined;
    license?: string | undefined;
    isDisplayTypeOrganization?: boolean | undefined;
    isDisplayTin?: boolean | undefined;
    isDisplayPhoneCompany?: boolean | undefined;
    isDisplayRegistrationAddress?: boolean | undefined;
    isDisplayPsrn?: boolean | undefined;
    isDisplayLicense?: boolean | undefined;
    name?: string | undefined;
    fullName?: string | undefined;
    phoneNumber?: string | undefined;
    description?: string | undefined;
    isDisplayPhoneNumber?: boolean | undefined;
    email?: string | undefined;
    isDisplayEmail?: boolean | undefined;
    isOracle?: boolean | undefined;
}

/** Query model 'Organization profile'. */
export class OrganizationProfileViewModel implements IOrganizationProfileViewModel {
    typeOrganization?: string | undefined;
    tin?: string | undefined;
    phoneCompany?: string | undefined;
    registrationAddress?: string | undefined;
    psrn?: string | undefined;
    license?: string | undefined;
    isDisplayTypeOrganization?: boolean | undefined;
    isDisplayTin?: boolean | undefined;
    isDisplayPhoneCompany?: boolean | undefined;
    isDisplayRegistrationAddress?: boolean | undefined;
    isDisplayPsrn?: boolean | undefined;
    isDisplayLicense?: boolean | undefined;
    name?: string | undefined;
    fullName?: string | undefined;
    phoneNumber?: string | undefined;
    description?: string | undefined;
    isDisplayPhoneNumber?: boolean | undefined;
    email?: string | undefined;
    isDisplayEmail?: boolean | undefined;
    isOracle?: boolean | undefined;

    constructor(data?: IOrganizationProfileViewModel) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if(data) {
            this.typeOrganization = data["typeOrganization"];
            this.tin = data["tin"];
            this.phoneCompany = data["phoneCompany"];
            this.registrationAddress = data["registrationAddress"];
            this.psrn = data["psrn"];
            this.license = data["license"];
            this.isDisplayTypeOrganization = data["isDisplayTypeOrganization"];
            this.isDisplayTin = data["isDisplayTin"];
            this.isDisplayPhoneCompany = data["isDisplayPhoneCompany"];
            this.isDisplayRegistrationAddress = data["isDisplayRegistrationAddress"];
            this.isDisplayPsrn = data["isDisplayPsrn"];
            this.isDisplayLicense = data["isDisplayLicense"];
            this.name = data["name"];
            this.fullName = data["fullName"];
            this.phoneNumber = data["phoneNumber"];
            this.description = data["description"];
            this.isDisplayPhoneNumber = data["isDisplayPhoneNumber"];
            this.email = data["email"];
            this.isDisplayEmail = data["isDisplayEmail"];
            this.isOracle = data["isOracle"];
        }
    }

    static fromJS(data: any): OrganizationProfileViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationProfileViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeOrganization"] = this.typeOrganization;
        data["tin"] = this.tin;
        data["phoneCompany"] = this.phoneCompany;
        data["registrationAddress"] = this.registrationAddress;
        data["psrn"] = this.psrn;
        data["license"] = this.license;
        data["isDisplayTypeOrganization"] = this.isDisplayTypeOrganization;
        data["isDisplayTin"] = this.isDisplayTin;
        data["isDisplayPhoneCompany"] = this.isDisplayPhoneCompany;
        data["isDisplayRegistrationAddress"] = this.isDisplayRegistrationAddress;
        data["isDisplayPsrn"] = this.isDisplayPsrn;
        data["isDisplayLicense"] = this.isDisplayLicense;
        data["name"] = this.name;
        data["fullName"] = this.fullName;
        data["phoneNumber"] = this.phoneNumber;
        data["description"] = this.description;
        data["isDisplayPhoneNumber"] = this.isDisplayPhoneNumber;
        data["email"] = this.email;
        data["isDisplayEmail"] = this.isDisplayEmail;
        data["isOracle"] = this.isOracle;
        return data;
    }
}

/** Query model 'Organization profile'. */
export interface IOrganizationProfileViewModel {
    typeOrganization?: string | undefined;
    tin?: string | undefined;
    phoneCompany?: string | undefined;
    registrationAddress?: string | undefined;
    psrn?: string | undefined;
    license?: string | undefined;
    isDisplayTypeOrganization?: boolean | undefined;
    isDisplayTin?: boolean | undefined;
    isDisplayPhoneCompany?: boolean | undefined;
    isDisplayRegistrationAddress?: boolean | undefined;
    isDisplayPsrn?: boolean | undefined;
    isDisplayLicense?: boolean | undefined;
    name?: string | undefined;
    fullName?: string | undefined;
    phoneNumber?: string | undefined;
    description?: string | undefined;
    isDisplayPhoneNumber?: boolean | undefined;
    email?: string | undefined;
    isDisplayEmail?: boolean | undefined;
    isOracle?: boolean | undefined;
}

/** Profile document pattern model */
export class ProfileDocumentPatternViewModel implements IProfileDocumentPatternViewModel {
    /** Profile id */
    profileId?: number | undefined;
    /** Name */
    name?: string | undefined;
    /** Description */
    description?: string | undefined;

    constructor(data?: IProfileDocumentPatternViewModel) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if(data) {
            this.profileId = data["profileId"];
            this.name = data["name"];
            this.description = data["description"];
        }
    }

    static fromJS(data: any): ProfileDocumentPatternViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileDocumentPatternViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profileId"] = this.profileId;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

/** Profile document pattern model */
export interface IProfileDocumentPatternViewModel {
    /** Profile id */
    profileId?: number | undefined;
    /** Name */
    name?: string | undefined;
    /** Description */
    description?: string | undefined;
}

/** Query model 'Change profile avatar'. */
export class ChangeProfileAvatarViewModel implements IChangeProfileAvatarViewModel {
    profileId?: number | undefined;
    avatarUrl?: string | undefined;

    constructor(data?: IChangeProfileAvatarViewModel) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if(data) {
            this.profileId = data["profileId"];
            this.avatarUrl = data["avatarUrl"];
        }
    }

    static fromJS(data: any): ChangeProfileAvatarViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeProfileAvatarViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profileId"] = this.profileId;
        data["avatarUrl"] = this.avatarUrl;
        return data;
    }
}

/** Query model 'Change profile avatar'. */
export interface IChangeProfileAvatarViewModel {
    profileId?: number | undefined;
    avatarUrl?: string | undefined;
}

export class ProfilesByTelegramResult implements IProfilesByTelegramResult {
    details?: ProfilesTelegram[] | undefined;

    constructor(data?: IProfilesByTelegramResult) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if(data) {
            if(Array.isArray(data["details"])) {
                this.details = [] as any;
                for (let item of data["details"])
                    this.details!.push(ProfilesTelegram.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProfilesByTelegramResult {
        data = typeof data === 'object' ? data : {};
        let result = new ProfilesByTelegramResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if(Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProfilesByTelegramResult {
    details?: ProfilesTelegram[] | undefined;
}

export class ProfilesTelegram implements IProfilesTelegram {
    profileId?: number | undefined;
    telegramId?: string | undefined;

    constructor(data?: IProfilesTelegram) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if(data) {
            this.profileId = data["profileId"];
            this.telegramId = data["telegramId"];
        }
    }

    static fromJS(data: any): ProfilesTelegram {
        data = typeof data === 'object' ? data : {};
        let result = new ProfilesTelegram();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profileId"] = this.profileId;
        data["telegramId"] = this.telegramId;
        return data;
    }
}

export interface IProfilesTelegram {
    profileId?: number | undefined;
    telegramId?: string | undefined;
}

export class ChangeProfileEmailViewModel implements IChangeProfileEmailViewModel {
    profileId?: number | undefined;
    isNewProfile?: boolean | undefined;
    email?: string | undefined;

    constructor(data?: IChangeProfileEmailViewModel) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if(data) {
            this.profileId = data["profileId"];
            this.isNewProfile = data["isNewProfile"];
            this.email = data["email"];
        }
    }

    static fromJS(data: any): ChangeProfileEmailViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeProfileEmailViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profileId"] = this.profileId;
        data["isNewProfile"] = this.isNewProfile;
        data["email"] = this.email;
        return data;
    }
}

export interface IChangeProfileEmailViewModel {
    profileId?: number | undefined;
    isNewProfile?: boolean | undefined;
    email?: string | undefined;
}

export class ConfirmChangeProfileEmailViewModel implements IConfirmChangeProfileEmailViewModel {
    profileId?: number | undefined;
    isNewProfile?: boolean | undefined;
    confirmationCode?: string | undefined;

    constructor(data?: IConfirmChangeProfileEmailViewModel) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if(data) {
            this.profileId = data["profileId"];
            this.isNewProfile = data["isNewProfile"];
            this.confirmationCode = data["confirmationCode"];
        }
    }

    static fromJS(data: any): ConfirmChangeProfileEmailViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmChangeProfileEmailViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profileId"] = this.profileId;
        data["isNewProfile"] = this.isNewProfile;
        data["confirmationCode"] = this.confirmationCode;
        return data;
    }
}

export interface IConfirmChangeProfileEmailViewModel {
    profileId?: number | undefined;
    isNewProfile?: boolean | undefined;
    confirmationCode?: string | undefined;
}

/** Query model 'Delete profile KYC field'. */
export class DeleteProfileKycFieldViewModel implements IDeleteProfileKycFieldViewModel {
    profileId?: number | undefined;
    type?: DeleteProfileKycFieldViewModelType | undefined;

    constructor(data?: IDeleteProfileKycFieldViewModel) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if(data) {
            this.profileId = data["profileId"];
            this.type = data["type"];
        }
    }

    static fromJS(data: any): DeleteProfileKycFieldViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteProfileKycFieldViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profileId"] = this.profileId;
        data["type"] = this.type;
        return data;
    }
}

/** Query model 'Delete profile KYC field'. */
export interface IDeleteProfileKycFieldViewModel {
    profileId?: number | undefined;
    type?: DeleteProfileKycFieldViewModelType | undefined;
}

/** Query model 'Subscribe to profile'. */
export class SubscribeViewModel implements ISubscribeViewModel {
    readonly profileId?: number | undefined;
    readonly subscriptionProfileId?: number | undefined;

    constructor(data?: ISubscribeViewModel) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if(data) {
            (<any>this).profileId = data["profileId"];
            (<any>this).subscriptionProfileId = data["subscriptionProfileId"];
        }
    }

    static fromJS(data: any): SubscribeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SubscribeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profileId"] = this.profileId;
        data["subscriptionProfileId"] = this.subscriptionProfileId;
        return data;
    }
}

/** Query model 'Subscribe to profile'. */
export interface ISubscribeViewModel {
    profileId?: number | undefined;
    subscriptionProfileId?: number | undefined;
}

export class CryptonomicaPromoCodeResult implements ICryptonomicaPromoCodeResult {
    promoCode?: string | undefined;
    discountInPercent?: number | undefined;

    constructor(data?: ICryptonomicaPromoCodeResult) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if(data) {
            this.promoCode = data["promoCode"];
            this.discountInPercent = data["discountInPercent"];
        }
    }

    static fromJS(data: any): CryptonomicaPromoCodeResult {
        data = typeof data === 'object' ? data : {};
        let result = new CryptonomicaPromoCodeResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["promoCode"] = this.promoCode;
        data["discountInPercent"] = this.discountInPercent;
        return data;
    }
}

export interface ICryptonomicaPromoCodeResult {
    promoCode?: string | undefined;
    discountInPercent?: number | undefined;
}

export class CryptonomicaVerificationResult implements ICryptonomicaVerificationResult {
    isVerified?: boolean | undefined;

    constructor(data?: ICryptonomicaVerificationResult) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if(data) {
            this.isVerified = data["isVerified"];
        }
    }

    static fromJS(data: any): CryptonomicaVerificationResult {
        data = typeof data === 'object' ? data : {};
        let result = new CryptonomicaVerificationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isVerified"] = this.isVerified;
        return data;
    }
}

export interface ICryptonomicaVerificationResult {
    isVerified?: boolean | undefined;
}

export class VerifyProfileRequest implements IVerifyProfileRequest {
    profileId?: number | undefined;
    fingerprint?: string | undefined;

    constructor(data?: IVerifyProfileRequest) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if(data) {
            this.profileId = data["profileId"];
            this.fingerprint = data["fingerprint"];
        }
    }

    static fromJS(data: any): VerifyProfileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyProfileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profileId"] = this.profileId;
        data["fingerprint"] = this.fingerprint;
        return data;
    }
}

export interface IVerifyProfileRequest {
    profileId?: number | undefined;
    fingerprint?: string | undefined;
}

export class CreateAccountRequest implements ICreateAccountRequest {
    password?: string | undefined;
    confirmPassword?: string | undefined;
    email?: string | undefined;
    accountType?: CreateAccountRequestAccountType | undefined;
    confirmationAction?: string | undefined;

    constructor(data?: ICreateAccountRequest) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if(data) {
            this.password = data["password"];
            this.confirmPassword = data["confirmPassword"];
            this.email = data["email"];
            this.accountType = data["accountType"];
            this.confirmationAction = data["confirmationAction"];
        }
    }

    static fromJS(data: any): CreateAccountRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAccountRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["password"] = this.password;
        data["confirmPassword"] = this.confirmPassword;
        data["email"] = this.email;
        data["accountType"] = this.accountType;
        data["confirmationAction"] = this.confirmationAction;
        return data;
    }
}

export interface ICreateAccountRequest {
    password?: string | undefined;
    confirmPassword?: string | undefined;
    email?: string | undefined;
    accountType?: CreateAccountRequestAccountType | undefined;
    confirmationAction?: string | undefined;
}

export class ConfirmEmailRequest implements IConfirmEmailRequest {
    email?: string | undefined;
    confirmationToken?: string | undefined;

    constructor(data?: IConfirmEmailRequest) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if(data) {
            this.email = data["email"];
            this.confirmationToken = data["confirmationToken"];
        }
    }

    static fromJS(data: any): ConfirmEmailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmEmailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["confirmationToken"] = this.confirmationToken;
        return data;
    }
}

export interface IConfirmEmailRequest {
    email?: string | undefined;
    confirmationToken?: string | undefined;
}

export class UserResponse implements IUserResponse {
    id?: string | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    accountType?: UserResponseAccountType | undefined;
    passwordChangeDate?: Date | undefined;

    constructor(data?: IUserResponse) {
        if(data) {
            for (var property in data) {
                if(data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if(data) {
            this.id = data["id"];
            this.email = data["email"];
            this.firstName = data["firstName"];
            this.lastName = data["lastName"];
            this.accountType = data["accountType"];
            this.passwordChangeDate = data["passwordChangeDate"] ? new Date(data["passwordChangeDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["accountType"] = this.accountType;
        data["passwordChangeDate"] = this.passwordChangeDate ? this.passwordChangeDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUserResponse {
    id?: string | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    accountType?: UserResponseAccountType | undefined;
    passwordChangeDate?: Date | undefined;
}

export enum ContractorSearchType {
    All = "All",
    CurrentProfile = "CurrentProfile",
}

export enum ContractorSearchType2 {
    All = "All",
    CurrentProfile = "CurrentProfile",
}

export enum OracleTabType {
    All = "All",
    CurrentProfile = "CurrentProfile",
}

export enum OracleTabType2 {
    All = "All",
    CurrentProfile = "CurrentProfile",
}

export enum OAuthRequestSystem {
    Google = "Google",
    Facebook = "Facebook",
    LinkedIn = "LinkedIn",
    Telegram = "Telegram",
    AppleId = "AppleId",
}

export enum ContractorModelProfileType {
    Personal = "Personal",
    Organization = "Organization",
}

export enum CountryDocumentFieldDocumentType {
    NotSelected = "NotSelected",
    Passport = "Passport",
    DriverLicense = "DriverLicense",
    NationalId = "NationalId",
}

export enum ProfileDocumentDocumentType {
    NotSelected = "NotSelected",
    Passport = "Passport",
    DriverLicense = "DriverLicense",
    NationalId = "NationalId",
}

export enum OrganizationAgentRequestType {
    Requested = "Requested",
    Accepted = "Accepted",
    Rejected = "Rejected",
    Canceled = "Canceled",
    Unbind = "Unbind",
    Deleted = "Deleted",
}

export enum UserAccountType {
    Personal = "Personal",
    Organization = "Organization",
}

export enum OracleModelProfileType {
    Personal = "Personal",
    Organization = "Organization",
}

export enum AgentResultRequestType {
    Requested = "Requested",
    Accepted = "Accepted",
    Rejected = "Rejected",
    Canceled = "Canceled",
    Unbind = "Unbind",
    Deleted = "Deleted",
}

export enum SetOrganizationAgentRequestTypeViewModelRequestType {
    Requested = "Requested",
    Accepted = "Accepted",
    Rejected = "Rejected",
    Canceled = "Canceled",
    Unbind = "Unbind",
    Deleted = "Deleted",
}

export enum ProfileDocumentResultDocumentType {
    NotSelected = "NotSelected",
    Passport = "Passport",
    DriverLicense = "DriverLicense",
    NationalId = "NationalId",
}

export enum ProfileDocumentViewModelDocumentType {
    NotSelected = "NotSelected",
    Passport = "Passport",
    DriverLicense = "DriverLicense",
    NationalId = "NationalId",
}

export enum DeleteProfileKycFieldViewModelType {
    Email = "Email",
    FullName = "FullName",
    BirthDate = "BirthDate",
    Country = "Country",
}

export enum CreateAccountRequestAccountType {
    Personal = "Personal",
    Organization = "Organization",
}

export enum UserResponseAccountType {
    Personal = "Personal",
    Organization = "Organization",
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if(result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if(!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}
